import globalConfig from '@utiles/officialStore/globalConfig';
const mainHost = globalConfig.getMainHost();
const gameInfoConfig = {
  // 日本江美
  2: {
    // 平台
    platform: 'jp',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'ja-JP',
    // 游戏简码
    gameCode: 'beauty',
    //游戏名
    gameName: '旦那様の一発逆転人生',
    //页面配置
    pageInfo: {
      pageTitle: '旦那様の一発逆転人生', // 页面title
      pageIco: require('@assets/image/officialWebStore/beauty/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/beauty/icon2.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/beauty/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'ja-JP': require('@assets/image/officialWebStore/beauty/logo.png') //日语logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/beauty/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        'ja-JP': [
          {
            img: require('@assets/image/officialWebStore/beauty/vipbanner.png'), // 图片
            link: `//auto-page.${mainHost}/jmvip01/` // 跳转
          }
        ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: '旦那様の一発逆転人生', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '12000', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              // 文案
              text: '6%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '120000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '600000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1200000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '2400000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              text: '12%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beauty/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/beauty/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـ旦那様の一発逆転人生  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom 旦那様の一発逆転人生-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the 旦那様の一発逆転人生 Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de 旦那様の一発逆転人生. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de 旦那様の一発逆転人生. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          '旦那様の一発逆転人生 bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional 旦那様の一発逆転人生  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  旦那様の一発逆転人生  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal 旦那様の一発逆転人生 Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『旦那様の一発逆転人生』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『旦那様の一発逆転人生』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          '旦那様の一発逆転人生 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 旦那様の一発逆転人生 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 旦那様の一発逆転人生 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny 旦那様の一発逆転人生. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações 旦那様の一発逆転人生. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «旦那様の一発逆転人生». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน 旦那様の一発逆転人生 อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน 旦那様の一発逆転人生 ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน 旦那様の一発逆転人生 เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya 旦那様の一発逆転人生 Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành 旦那様の一発逆転人生 có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành 旦那様の一発逆転人生 chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành 旦那様の一発逆転人生 xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          '旦那様の一発逆転人生 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 旦那様の一発逆転人生 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 旦那様の一発逆転人生 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          '旦那様の一発逆転人生 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 旦那様の一発逆転人生 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 旦那様の一発逆転人生 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        {
          link: `//auto-page.${mainHost}/jmsf210/`, // 跳转链接
          linkKey: '', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/beauty/welfare-ico-1.png'), //ico
          defaultLang: 'ja-JP', // 文案默认语言
          text: {
            // 文案配置
            'ja-JP': '累計チャージで報酬獲得'
          }
        }
        // {
        //   link: `//auto-page.${mainHost}/jmzn01/`, // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/beauty/welfare-ico-2.png'), //ico
        //   defaultLang: 'ja-JP', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'ja-JP': '時空を超える恋'
        //   }
        // }
      ],
      // 社群列表
      communityList: [
        {
          link: window.atob('aHR0cHM6Ly94LmNvbS8zN2dhbWVzX2JlYXV0eQ=='), // 跳转链接
          linkKey: 'twitter', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-twitter-ico.png'), //ico
          btnColor: '#000000', // 按钮颜色
          text: {
            // 文案配置
            'ja-JP': 'X'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/beauty/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/beauty/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/beauty/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/beauty/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'ja-JP': [
        require('@assets/image/officialWebStore/beauty/beauty-currency-guide.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#933e8c', //渐变按钮左
      gradientBtnRight: '#c467a7', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#cd3fa0', //所有框体边框色高亮
      borderActiveShade: '#ffd0f0', // 所有框体边框高亮阴影色
      btnBg: '#cd3fa0', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#ffd0f0', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: true, // 是否开启
      defaultLang: 'ja-JP', // 默认语言
      resource: {
        'ja-JP': {
          close: require('@assets/image/officialWebStore/beauty/welcome-popup-close.png'), //关闭按钮
          bg: require('@assets/image/officialWebStore/beauty/welcome-popup-bg.png'), //背景图
          btn: require('@assets/image/officialWebStore/beauty/welcome-popup-btn.png'), //按钮
          link: `//auto-page.${mainHost}/jmzd01/` //跳转链接
        }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    isShowPreRightsPopup: false, // 是否展示上线前弹窗
    offLineTime: '2024-11-14T23:59:59+09:00', // 公告下线时间后不再弹窗时间，需加上时区信息
    offLineDate: {
      'zh-TW': '2024-11-14 23:59:59 (UTC+9)',
      'zh-CN': '2024-11-14 23:59:59 (UTC+9)',
      'vi-VN': '23:59:59 (UTC+9) ngày 14/11/2024',
      'tr-TR': '14/11/2024 23.59.59 (UTC+9)',
      'th-TH': '2024-11-14 เวลา 23:59:59 น.(UTC+9)',
      'ru-RU': '2024/11/14 23:59:59 (UTC+9)',
      'pt-PT': '14/11/2024 23:59:59 (UTC+9)',
      'pl-PL': '2024/11/14 23:59:59 (UTC+9)',
      'ko-KR': '2024-11-14 23:59:59(UTC+9)',
      'ja-JP': '2024 年 11 月 14 日 23:59:59(UTC+9)',
      'it-IT': '14/11/2024 23:59:59 (UTC+9)',
      'id-ID': '14/11/2024 23:59:59 (UTC+9)',
      'fr-FR': '14/11/2024 23:59:59 (UTC+9)',
      'es-ES': '14/11/2024 23:59:59 (UTC+9)',
      'en-US': '2024/11/14 23:59:59 (UTC+9)',
      'de-DE': '14.11.2024, 23:59:59 Uhr (UTC+9)',
      'ar-SA': '14-11-2024 23:59:59 (UTC+9)'
    }, // 配置公告下线时间
    preRightsPopupLink: '', // 上线前弹窗链接
    isOnlineRightsCenter: true, // 是否上线权益中心
    rightsCenterLink: `//auto-page.${mainHost}/jmvip01/`, // 权益中心链接
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    },
    uidGuidePopupGameImg1: require('@assets/image/officialWebStore/beauty/uid-guide-img-1.jpeg'),
    uidGuidePopupGameImg2: require('@assets/image/officialWebStore/beauty/uid-guide-img-2.jpeg')
  },
  // 全球智城战纪
  175: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'tmslg',
    //游戏名
    gameName: 'Puzzles & Conquest',
    //页面配置
    pageInfo: {
      pageTitle: 'PnC official top-up', // 页面title
      pageIco: require('@assets/image/officialWebStore/tmslg/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/tmslg/icon175.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/tmslg/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/tmslg/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/tmslg/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        'en-US': [
          {
            img: require('@assets/image/officialWebStore/tmslg/banner.png'), // 图片
            link: `//auto-page.${mainHost}/zclc01/` // 跳转
          }
        ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Puzzles & Conquest', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '20', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '200',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '500',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              text: '11%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              text: '13%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              text: '11%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '2000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              text: '11%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tmslg/zc-coupon.png'),
              text: '13%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1YZ1XybJuJOLEYIIIx_mOnehr7GNKLcQHzpZYgtlQOZk/edit?usp=sharing',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/tmslg/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـPuzzle & Survival  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Puzzle & Survival-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the Puzzle & Survival Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Puzzle & Survival. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Puzzle & Survival. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'Puzzles & Conquest bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Puzzles & Conquest  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  Puzzles & Conquest  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Puzzle & Survival Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『Puzzles & Conquest』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『Puzzles & Conquest』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          'Puzzles & Conquest 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 Puzzles & Conquest 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 Puzzles & Conquest 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Puzzle & Survival. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Puzzle & Survival. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Puzzle & Survival». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน Puzzles & Conquest อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน Puzzles & Conquest ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน Puzzles & Conquest เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya Puzzle & Survival Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành Puzzles & Conquest có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Puzzles & Conquest chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Puzzles & Conquest xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'Puzzles & Conquest 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Puzzles & Conquest 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 Puzzles & Conquest 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'Puzzles & Conquest 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Puzzles & Conquest 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 Puzzles & Conquest 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        {
          link: `//auto-page.${mainHost}/zclc01/`, // 跳转链接
          linkKey: '', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/welfare-ico-2.png'), //ico
          defaultLang: 'en-US', // 文案默认语言
          text: {
            // 文案配置
            'en-US': 'Top-up Reward！'
          }
        }
      ],
      // 社群列表
      communityList: [
        {
          link: window.atob('aHR0cHM6Ly93d3cuZmFjZWJvb2suY29tL1BuQy4zN0dhbWVz'), // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        },
        {
          link: 'https://discord.gg/vHTeG43K7E', // 跳转链接
          linkKey: 'discord', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-discord-ico.png'), //ico
          btnColor: '#6665d2', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Discord'
          }
        },
        {
          link: `https://auto-page.${mainHost}/tmslgzzy/`, // 跳转链接
          linkKey: 'homepage', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-website-ico.png'), //ico
          btnColor: '#ffa200', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Game Website'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/tmslg/defaultProductIco2.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/tmslg/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/tmslg/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/tmslg/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/tmslg/tmslg-currency-guide-1.png'),
        require('@assets/image/officialWebStore/tmslg/tmslg-currency-guide-2.png'),
        require('@assets/image/officialWebStore/tmslg/tmslg-currency-guide-3.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#3b90f3', //渐变按钮左
      gradientBtnRight: '#8ec2ff', //渐变按钮右
      border: '#dddddd', //所有框体边框色
      borderActive: '#3b90f3', //所有框体边框色高亮
      borderActiveShade: '#cbe1fd', // 所有框体边框高亮阴影色
      btnBg: '#3b90f3', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#7ab4f8', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#cee5ff', //渐变背景左
      gradientBgRight: '#e6f2ff', //渐变背景右
      popupSubBtn: '#ffb330', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#ebf4ff' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    isShowPreRightsPopup: true, // 是否展示上线前弹窗
    offLineTime: '2025-06-23T23:59:59Z', // 公告下线时间后不再弹窗时间，需加上时区信息
    offLineDate: {
      'zh-TW': '2025-06-23 23:59:59 (UTC)',
      'zh-CN': '2025-06-23 23:59:59 (UTC)',
      'vi-VN': '23:59:59 (UTC) ngày 23/06/2025',
      'tr-TR': '23.59.59 (UTC) 23/06/2025',
      'th-TH': '2025-06-23 เวลา 23:59:59 น.(UTC)',
      'ru-RU': '2025/06/23 23:59:59 (UTC)',
      'pt-PT': '23/06/2025 23:59:59 (UTC)',
      'pl-PL': '2025/06/23 23:59:59 (UTC)',
      'ko-KR': '2025-06-23 23:59:59(UTC)',
      'ja-JP': '2025 年 6 月 23 日 23:59:59(UTC)',
      'it-IT': '23/06/2025 23:59:59 (UTC)',
      'id-ID': '23/6/2025 23:59:59 (UTC)',
      'fr-FR': '23/06/2025 23:59:59 (UTC)',
      'es-ES': '23/06/2025 23:59:59 (UTC)',
      'en-US': '2025/06/23 23:59:59 (UTC)',
      'de-DE': '23.06.2025, 23:59:59 Uhr (UTC)',
      'ar-SA': '23-06-2025 23:59:59 (UTC)'
    }, // 配置公告下线时间
    preRightsPopupLink: '', // 上线前弹窗链接
    isOnlineRightsCenter: true, // 是否上线权益中心
    rightsCenterLink: `//auto-page.${mainHost}/zcvip01//`, // 权益中心链接
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    },
    // 是否自定义商品分类名称、ico
    isCustomProductType: true,
    productType: {
      typeall: {
        order: 1,
        img: require('@assets/image/officialWebStore/tmslg/productType/typeall.png')
      },
      type1: {
        order: 2,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_libao.png')
      },
      type2: {
        order: 102,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_biaoqianlongchong_mtdl.png')
      },
      type3: {
        order: 103,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_biaoqiajunshi.png')
      },
      type5: {
        order: 104,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_biaoqianbaoshi.png')
      },
      type6: {
        order: 107,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_biaoqiannvwusheng.png')
      },
      type7: {
        order: 108,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_biaoqianziyuan.png')
      },
      type8: {
        order: 109,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_biaoqianjianzaoyanfa.png')
      },
      // type9: {
      //   order: 110,
      //   img: require('@assets/image/officialWebStore/tmslg/productType/ico_biaoqianbaowu.png')
      // },
      type10: {
        order: 110,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_lianmengliwu.png')
      },
      type11: {
        order: 113,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_biaoqianshuijing.png')
      },
      type12: {
        order: 105,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_biaoqianlonghunshi.png')
      },
      type13: {
        order: 106,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_biaoqianzhanwen.png')
      },
      type999: {
        order: 0,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_shangchengdaijinquan.png')
      },
      type9999: {
        order: 101,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_chaozhilibao.png')
      },
      type10000: {
        order: 5,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_fulizhongxin.png')
      },
      type10001: {
        order: 4,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_biaoqianyuemaiyuezhi.png')
      },
      type14: {
        order: 106,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_xianshiyouxuan.png')
      },
      type15: {
        order: 111,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_biaoqianyingxiongbaowu.png')
      },
      type16: {
        order: 6,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_zhongjidajiang.png')
      },
      type17: {
        order: 9,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_lingzhuwaiguanlibao.png')
      },
      type18: {
        order: 10,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_xingjunlibao.png')
      },
      type22: {
        order: 7,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_zhongjidajiang.png')
      },
      type23: {
        order: 8,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_zhongjidajiang.png')
      },
      type25: {
        order: 107,
        img: require('@assets/image/officialWebStore/tmslg/productType/ico_sdsl.png')
      },
      typeother: {
        order: 9999,
        img: require('@assets/image/officialWebStore/tmslg/productType/typeother.png')
      }
    },
    //  商品分类翻译
    productTypeLang: {
      'ar-SA': {
        type1: 'الصفقة اليومية',
        type2: 'زعيم',
        type3: 'عتاد المعركة',
        type5: 'المجوهرات',
        type6: 'التنين العظيم',
        type7: 'المورد',
        type8: 'البناء والبحث',
        type9: 'أخرى',
        type10: 'التحالف',
        type11: 'الألماس',
        type12: 'جوهرة التنين',
        type13: 'ختم الحرب',
        type999: 'القسيمة',
        type9999: 'الهدية الشهرية',
        type10000: 'مركز الهدايا',
        type10001: 'أحداث العطلات',
        type14: 'عرض خاص لفترة محدودة',
        type15: 'تحفة البطل',
        type16: '5 أيام متتالية الحزمة',
        type17: 'رمز مظهر القائد',
        type18: 'تأثير المسيرة',
        type22: '5 أيام متتالية الحزمة',
        type23: '5 أيام متتالية الحزمة',
        type25: 'رون'
      },
      'de-DE': {
        type1: 'Tägliches Angebot',
        type2: 'Held',
        type3: 'Kampfausrüstung',
        type5: 'Juwel',
        type6: 'Sauroi',
        type7: 'Ressource',
        type8: 'Bauen & forschen',
        type9: 'Andere',
        type10: 'Allianz',
        type11: 'Diamant',
        type12: 'Saurierjuwel',
        type13: 'Kriegssiegel',
        type999: 'Gutschein',
        type9999: 'Monatsgeschenk',
        type10000: 'Geschenk-Center',
        type10001: 'Feiertags-Events',
        type14: 'Zeitlich begrenztes Sonderangebot',
        type15: 'Held-Rarität',
        type16: '5 Tage in Folge Paket',
        type17: 'Lord Look Emblem',
        type18: 'Marsch Effekt',
        type22: '5 Tage in Folge Paket',
        type23: '5 Tage in Folge Paket',
        type25: 'Rune'
      },
      'en-US': {
        type1: 'Daily Sale',
        type2: 'Hero',
        type3: 'Battle Gear',
        type5: 'Gem',
        type6: 'Sauroi',
        type7: 'Resource',
        type8: 'Build & Research',
        type9: 'Other',
        type10: 'Alliance',
        type11: 'Diamond',
        type12: 'Saurgem',
        type13: 'Warsigil',
        type999: 'Voucher',
        type9999: 'Monthly Gift',
        type10000: 'Gift Center',
        type10001: 'Holiday Events',
        type14: 'Time-limited Special Offer',
        type15: 'Hero Curio',
        type16: '5-day Consec. Pack',
        type17: 'Lord Look Emblem',
        type18: 'March Effect',
        type22: '5-day Consec. Pack',
        type23: '5-day Consec. Pack',
        type25: 'Rune'
      },
      'es-ES': {
        type1: 'Ofertas Diarias',
        type2: 'Héroe',
        type3: 'Maquinaria de Batalla',
        type5: 'Gema',
        type6: 'Sauroi',
        type7: 'Recursos',
        type8: 'Construir e Investigar',
        type9: 'Otro',
        type10: 'Alianza',
        type11: 'Diamante',
        type12: 'Gema de Saur',
        type13: 'Sigil de Guerra',
        type999: 'Cupón',
        type9999: 'Regalo Mensual',
        type10000: 'Centro de Regalos',
        type10001: 'Eventos de vacaciones',
        type14: 'Oferta especial por tiempo limitado',
        type15: 'Curio de Héroes',
        type16: 'Paquete Consec. de 5 días',
        type17: 'Emblema de la apariencia del Señor',
        type18: 'Efecto de marcha',
        type22: 'Paquete Consec. de 5 días',
        type23: 'Paquete Consec. de 5 días',
        type25: 'Runa'
      },
      'fr-FR': {
        type1: 'Remises quotidiennes',
        type2: 'héros',
        type3: 'Équipement bataille',
        type5: 'Gemme',
        type6: 'Sauroi',
        type7: 'Ressources',
        type8: 'Construction & Recherche',
        type9: 'Autre',
        type10: 'Alliance',
        type11: 'Diamant',
        type12: 'Puissance Noyau',
        type13: 'Sceau de guerre',
        type999: 'Coupon',
        type9999: 'Cadeau mensuel',
        type10000: 'Centre cadeau',
        type10001: 'Événements des vacances',
        type14: 'Offre spéciale à durée limitée',
        type15: 'Artefact de héros',
        type16: 'Pack consécutif 5 jours',
        type17: "Emblème d'apparence de seigneur",
        type18: 'Effet de marche',
        type22: 'Pack consécutif 5 jours',
        type23: 'Pack consécutif 5 jours',
        type25: 'Rune'
      },
      'id-ID': {
        type1: 'Daily Sale',
        type2: 'Hero',
        type3: 'Battle Gear',
        type5: 'Gem',
        type6: 'Sauroi',
        type7: 'Resource',
        type8: 'Build & Research',
        type9: 'Other',
        type10: 'Alliance',
        type11: 'Diamond',
        type12: 'Saurgem',
        type13: 'Warsigil',
        type999: 'Voucher',
        type9999: 'Monthly Gift',
        type10000: 'Gift Center',
        type10001: 'Holiday Events',
        type14: 'Time-limited Special Offer',
        type15: 'Hero Curio',
        type16: '5-day Consec. Pack',
        type17: 'Lord Look Emblem',
        type18: 'March Effect',
        type22: '5-day Consec. Pack',
        type23: '5-day Consec. Pack',
        type25: 'Rune'
      },
      'it-IT': {
        type1: 'Vendita Giornaliera',
        type2: 'Eroe',
        type3: 'Equip. Battaglia',
        type5: 'Gemma',
        type6: 'Sauroi',
        type7: 'Risorse',
        type8: 'Costruisci & Ricerca',
        type9: 'Altro',
        type10: 'Alleanza',
        type11: 'Diamante',
        type12: 'Gemma Saur',
        type13: 'Warsigil',
        type999: 'Buoni',
        type9999: 'Regalo Mensile',
        type10000: 'Centro Regali',
        type10001: 'Eventi Festività',
        type14: 'Offerta Speciale a Tempo Limitato',
        type15: 'Eroe Curio',
        type16: 'Pacchetto 5 Giorni Consecutivi',
        type17: 'Emblema Aspetto Signore',
        type18: 'Effetto Marcia',
        type22: 'Pacchetto 5 Giorni Consecutivi',
        type23: 'Pacchetto 5 Giorni Consecutivi',
        type25: 'Runa'
      },
      'ja-JP': {
        type1: 'デイリーBONUS',
        type2: '英雄',
        type3: '戦闘装備',
        type5: 'ジェム',
        type6: '巨竜',
        type7: '資源',
        type8: '建造研究',
        type9: 'Other',
        type10: 'ギルド',
        type11: 'ダイヤ',
        type12: '龍魂石',
        type13: 'ウォーエンブレム',
        type999: '預かり証',
        type9999: 'マンスリーギフト',
        type10000: 'サービスセンター',
        type10001: 'ホリデーイベント',
        type14: 'スーパー限定',
        type15: '英雄聖物',
        type16: '5日累計パック',
        type17: 'ロードイメージエンブレム',
        type18: '進軍効果',
        type22: '5日累計パック',
        type23: '5日累計パック',
        type25: 'ルーン'
      },
      'ko-KR': {
        type1: '일일 특혜',
        type2: '영웅',
        type3: '전투 장비',
        type5: 'Gem',
        type6: 'Sauroi',
        type7: '자원',
        type8: '건설개발',
        type9: '기타',
        type10: '연맹',
        type11: '다이아',
        type12: 'Saurgem',
        type13: 'Warsigil',
        type999: '쿠폰',
        type9999: '월간 선물',
        type10000: '기프트 센터',
        type10001: '기념일 이벤트',
        type14: '한정 우선',
        type15: '영웅 성물',
        type16: '일 연속 패키지',
        type17: '영주 이미지 엠블럼',
        type18: '행군 이펙트',
        type22: '일 연속 패키지',
        type23: '일 연속 패키지',
        type25: '룬'
      },
      'pl-PL': {
        type1: 'Wyprzedaż Dzienna',
        type2: 'Heros',
        type3: 'Sprzęt Bitewny',
        type5: 'Klejnot',
        type6: 'Sauroi',
        type7: 'Zasób',
        type8: 'Buduj i Prowadź Badania',
        type9: 'Inne',
        type10: 'Sojusz',
        type11: 'Diament',
        type12: 'Saurgem',
        type13: 'Warsigil',
        type999: 'Voucher',
        type9999: 'Podarunek Miesiąca',
        type10000: 'Centrum Podarunkowe',
        type10001: 'Wydarzenia Świąteczne',
        type14: 'Specjalna Oferta Ograniczona Czasowo',
        type15: 'Curio Herosa',
        type16: 'Pakiet 5 dni pod rząd',
        type17: 'Emblem Wyglądu Lorda',
        type18: 'Efektu Marszu',
        type22: 'Pakiet 5 dni pod rząd',
        type23: 'Pakiet 5 dni pod rząd',
        type25: 'Runa'
      },
      'pt-PT': {
        type1: 'Promoção Diária',
        type2: 'Herói',
        type3: 'Equipamento de Batalha',
        type5: 'Gema',
        type6: 'Sauroi',
        type7: 'Recurso',
        type8: 'Construção & Pesquisa',
        type9: 'Outros',
        type10: 'Aliança',
        type11: 'Diamante',
        type12: 'Gemasaur',
        type13: 'Guerreiro',
        type999: 'Bilhetes de Preço',
        type9999: 'Presente Mensal',
        type10000: 'Centro de Presentes',
        type10001: 'Eventos Comemorativos',
        type14: 'Oferta Especial de Tempo Limitado',
        type15: 'Relíquia de Herói',
        type16: 'Pacote de 5 dias consecutivos',
        type17: 'Emblema de Visual do Lorde',
        type18: 'Efeito de Marcha',
        type22: 'Pacote de 5 dias consecutivos',
        type23: 'Pacote de 5 dias consecutivos',
        type25: 'Runa'
      },
      'ru-RU': {
        type1: 'Распродажа Дня',
        type2: 'Герои',
        type3: 'Боевое Снаряжение',
        type5: 'Самоцвет',
        type6: 'Саурой',
        type7: 'Ресурсы',
        type8: 'Стройка и Наука',
        type9: 'Другое',
        type10: 'Альянс',
        type11: 'Алмаз',
        type12: 'Драконий Самоцвет',
        type13: 'Военная Эмблема',
        type999: 'Ваучер',
        type9999: 'Ежемесячный Подарок',
        type10000: 'Центр Подарков',
        type10001: 'Праздничные События',
        type14: 'Особая Временная Распродажа',
        type15: 'Героическая Реликвия',
        type16: 'Набор 5-дн. Серии Покупок',
        type17: 'Эмблема Внешности Лорда',
        type18: 'Походный Эффект',
        type22: 'Набор 5-дн. Серии Покупок',
        type23: 'Набор 5-дн. Серии Покупок',
        type25: 'Руна'
      },
      'th-TH': {
        type1: 'ราคาพิเศษรายวัน',
        type2: 'ฮีโร่',
        type3: 'อุปกรณ์สู้รบ',
        type5: 'ผลึก',
        type6: 'มังกรยักษ์',
        type7: 'ทรัพยากร',
        type8: 'สร้างวิจัย',
        type9: 'อื่นๆ',
        type10: 'สมาพันธ์',
        type11: 'เพชร',
        type12: 'หินวิญญาณมังกร',
        type13: 'ลายสงคราม',
        type999: 'คูปอง',
        type9999: 'ของขวัญรายเดือน',
        type10000: 'ศูนย์สวัสดิการ',
        type10001: 'กิจกรรมเทศกาล',
        type14: 'โปรฯจำกัดเวลา',
        type15: 'ของวิเศษฮีโร่',
        type16: 'แพ็คต่อเนื่อง5วัน',
        type17: 'เข็มยศรูปท่านลอร์ด',
        type18: 'ผลเดินทัพ',
        type22: 'แพ็คต่อเนื่อง5วัน',
        type23: 'แพ็คต่อเนื่อง5วัน',
        type25: 'รูน'
      },
      'tr-TR': {
        type1: 'Günlük İndirim',
        type2: 'Kahraman',
        type3: 'Savaş Teçhizatı',
        type5: 'Mücevher',
        type6: 'Sauroi',
        type7: 'Kaynak',
        type8: 'İnşa & Araştırma',
        type9: 'Diğer',
        type10: 'İttifak',
        type11: 'Elmas',
        type12: 'Saurotaşı',
        type13: 'Savaşmührü',
        type999: 'Kupon',
        type9999: 'Aylık Hediye',
        type10000: 'Hediye Merkezi',
        type10001: 'Tatil Etkinlikleri',
        type14: 'Zaman-sınırlı Özel Teklif',
        type15: 'Kahraman Antikası',
        type16: '5-günlük Ardışık Paket',
        type17: 'Lord Görünüm Amblemi',
        type18: 'Yürüyüş Efekti',
        type22: '5-günlük Ardışık Paket',
        type23: '5-günlük Ardışık Paket',
        type25: 'Rün'
      },
      'vi-VN': {
        type1: 'Ưu Đãi Hàng Ngày',
        type2: 'Anh Hùng',
        type3: 'Trang bị chiến đấu',
        type5: 'Ngọc',
        type6: 'Rồng Khổng Lồ',
        type7: 'Tài nguyên',
        type8: 'Xây dựng nghiên cứu',
        type9: 'Khác',
        type10: 'Liên Minh',
        type11: 'Kim Cương',
        type12: 'Đá Hồn Rồng',
        type13: 'Chiến Văn',
        type999: 'Voucher',
        type9999: 'Quà Hàng Tháng',
        type10000: 'Trung Tâm Phúc Lợi',
        type10001: 'Sự kiện ngày tết',
        type14: 'Ưu tiên chọn mua hạn giờ',
        type15: 'Thánh Vật Anh Hùng',
        type16: 'Gói Mua Liền 5 Ngày',
        type17: 'Huy Chương hình tượng Lãnh Chúa',
        type18: 'Hiệu ứng Hành Quân',
        type22: 'Gói Mua Liền 5 Ngày',
        type23: 'Gói Mua Liền 5 Ngày',
        type25: 'Cổ Ngữ'
      },
      'zh-CN': {
        type1: '每日特惠',
        type2: '英雄',
        type3: '战斗装备',
        type5: '宝石',
        type6: '巨龙',
        type7: '资源',
        type8: '建造研发',
        type9: '其他',
        type10: '联盟',
        type11: '钻石',
        type12: '龙魂石',
        type13: '战纹',
        type999: '代金券',
        type9999: '月度好礼',
        type10000: '福利中心',
        type10001: '节日活动',
        type14: '限时优选',
        type15: '英雄圣物',
        type16: '五日连续礼包',
        type17: '领主形象徽章',
        type18: '行军效果',
        type22: '五日连续礼包',
        type23: '五日连续礼包',
        type25: '符文'
      },
      'zh-TW': {
        type1: '每日特惠',
        type2: '英雄',
        type3: '戰鬥裝備',
        type5: '寶石',
        type6: '巨龍',
        type7: '資源',
        type8: '建造研發',
        type9: '其他',
        type10: '聯盟',
        type11: '鑽石',
        type12: '龍魂石',
        type13: '戰紋',
        type999: '代金券',
        type9999: '月度好禮',
        type10000: 'Gift Center',
        type10001: 'Holiday Events',
        type14: '限時優選',
        type15: '英雄聖物',
        type16: '五日連續禮包',
        type17: '領主形象徽章',
        type18: '行軍效果',
        type22: '五日連續禮包',
        type23: '五日連續禮包',
        type25: '符文'
      }
    }
  },
  // 全球帝国SLG
  269: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'dgslg',
    //游戏名
    gameName: 'Game of Empires: Warring Realms',
    //页面配置
    pageInfo: {
      pageTitle: 'GOE official top-up', // 页面title
      pageIco: require('@assets/image/officialWebStore/dgslg/logo.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/dgslg/icon180.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/dgslg/top-bar.jpg'),
    //顶部栏logo、pc端侧边栏logo
    logo: {
      'en-US': require('@assets/image/officialWebStore/dgslg/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/dgslg/banner.png'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/tmslg/banner.png'), // 图片
        //     link: '//www.baidu.com' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Game of Empires: Warring Realms', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              text: '11%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              text: '13%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              text: '11%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              text: '11%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dgslg/dg-coupon.png'),
              text: '13%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],

      link: 'https://docs.google.com/spreadsheets/d/1YZ1XybJuJOLEYIIIx_mOnehr7GNKLcQHzpZYgtlQOZk/edit?usp=sharing',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/dgslg/vip-banner-bg.jpg')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـGame of Empires: Warring Realms  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Game of Empires: Warring Realms-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the Game of Empires: Warring Realms Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Game of Empires: Warring Realms. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Game of Empires: Warring Realms. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'Game of Empires: Warring Realms bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Game of Empires: Warring Realms  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  Game of Empires: Warring Realms  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Game of Empires: Warring Realms Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『Game of Empires: Warring Realms』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『Game of Empires: Warring Realms』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          'Game of Empires: Warring Realms 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 Game of Empires: Warring Realms 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 Game of Empires: Warring Realms 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Game of Empires: Warring Realms. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Game of Empires: Warring Realms. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Game of Empires: Warring Realms». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน Game of Empires: Warring Realms อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน Game of Empires: Warring Realms ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน Game of Empires: Warring Realms เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya Game of Empires: Warring Realms Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành Game of Empires: Warring Realms có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Game of Empires: Warring Realms chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Game of Empires: Warring Realms xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'Game of Empires: Warring Realms 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Game of Empires: Warring Realms 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 Game of Empires: Warring Realms 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'Game of Empires: Warring Realms 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Game of Empires: Warring Realms 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 Game of Empires: Warring Realms 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: '//www.baidu.com', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/welfare-ico-1.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Share for Gifts',
        //     'zh-CN': '分享活动'
        //   }
        // },
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/gameofempiresofficial', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        },
        {
          link: 'https://discord.gg/game-of-empires-933539735694094356', // 跳转链接
          linkKey: 'discord', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-discord-ico.png'), //ico
          btnColor: '#6665d2', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Discord'
          }
        },
        {
          link: 'https://www.goeofficial.com/?cid=pay&scid=actlist&store=1', // 跳转链接
          linkKey: 'homepage', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-website-ico.png'), //ico
          btnColor: '#ffa200', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Game Website'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/dgslg/default-product-img.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/dgslg/coin.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/dgslg/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/dgslg/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/dgslg/dgslg-currency-guide-en-1.png'),
        require('@assets/image/officialWebStore/dgslg/dgslg-currency-guide-en-2.png')
      ],
      'fr-FR': [
        require('@assets/image/officialWebStore/dgslg/dgslg-currency-guide-fr-1.png'),
        require('@assets/image/officialWebStore/dgslg/dgslg-currency-guide-fr-2.png')
      ],
      'de-DE': [
        require('@assets/image/officialWebStore/dgslg/dgslg-currency-guide-de-1.png'),
        require('@assets/image/officialWebStore/dgslg/dgslg-currency-guide-de-2.png')
      ],
      'id-ID': [
        require('@assets/image/officialWebStore/dgslg/dgslg-currency-guide-id-1.png'),
        require('@assets/image/officialWebStore/dgslg/dgslg-currency-guide-id-2.png')
      ],
      'ru-RU': [
        require('@assets/image/officialWebStore/dgslg/dgslg-currency-guide-ru-1.png'),
        require('@assets/image/officialWebStore/dgslg/dgslg-currency-guide-ru-2.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#896f46', //渐变按钮左
      gradientBtnRight: '#c2a574', //渐变按钮右
      border: '#dddddd', //所有框体边框色
      borderActive: '#d1b993', //所有框体边框色高亮
      borderActiveShade: '#eee4d2', // 所有框体边框高亮阴影色
      btnBg: '#876e45', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#e9e0ce', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#896f46', //渐变背景左
      gradientBgRight: '#c2a574', //渐变背景右
      popupSubBtn: '#ffb330', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#e3d0ae' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 全球巨兽
  295: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'beast',
    //游戏名
    gameName: 'Mecha Domination: Rampage',
    //页面配置
    pageInfo: {
      pageTitle: 'MCD official Top-Up', // 页面title
      pageIco: require('@assets/image/officialWebStore/beast/mcd-yeqian.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/beast/mcd-ico.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/beast/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo
    logo: {
      'en-US': require('@assets/image/officialWebStore/beast/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/beast/banner.png'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        'en-US': (() => {
          const arr = [
            {
              img: require('@assets/image/officialWebStore/beast/banner-1.png'), // 图片
              link: `//auto-page.${mainHost}/restart1/` // 跳转
            }
          ];
          return arr;
        })()
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Mecha Domination: Rampage', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      // 当前vip未打开，打开的时候请配置具体奖励规则
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              text: '11%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              text: '13%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              text: '11%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              text: '11%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/beast/vip-coupon.png'),
              text: '13%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],

      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/beast/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـMecha Domination: Rampage  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Mecha Domination: Rampage-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the Mecha Domination: Rampage Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Mecha Domination: Rampage. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Mecha Domination: Rampage. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'Mecha Domination: Rampage bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Mecha Domination: Rampage  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  Mecha Domination: Rampage  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Mecha Domination: Rampage Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『Mecha Domination: Rampage』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『Mecha Domination: Rampage』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          'Mecha Domination: Rampage 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 Mecha Domination: Rampage 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 Mecha Domination: Rampage 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Mecha Domination: Rampage. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Mecha Domination: Rampage. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Mecha Domination: Rampage». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน Mecha Domination: Rampage อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน Mecha Domination: Rampage ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน Mecha Domination: Rampage เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya Mecha Domination: Rampage Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành Mecha Domination: Rampage có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Mecha Domination: Rampage chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Mecha Domination: Rampage xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'Mecha Domination: Rampage 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Mecha Domination: Rampage 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 Mecha Domination: Rampage 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'Mecha Domination: Rampage 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Mecha Domination: Rampage 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 Mecha Domination: Rampage 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: (() => {
        const arr = [
          {
            link: `//auto-page.${mainHost}/jushoupurchase_0814/`, // 跳转链接
            linkKey: '', // 链接key，用于打点上报
            ico: require('@assets/image/officialWebStore/beast/welfare-ico-1.png'), //ico
            defaultLang: 'en-US', // 文案默认语言
            text: {
              // 文案配置
              'en-US': 'Claim your Reward！'
            }
          }
        ];

        const nowDate = new Date().toISOString();

        if (nowDate < '2025-12-20T23:59:59Z') {
          arr.unshift({
            link: `//auto-page.${mainHost}/jscz07/`, // 跳转链接
            linkKey: '', // 链接key，用于打点上报
            ico: require('@assets/image/officialWebStore/beast/welfare-ico-3.png'), //ico
            defaultLang: 'en-US', // 文案默认语言
            text: {
              // 文案配置
              'en-US': 'Luxury Lucky Draw'
            }
          });
        }

        if (nowDate < '2026-01-06T23:59:59Z') {
          arr.unshift({
            link: `//auto-page.${mainHost}/jscb11/`, // 跳转链接
            linkKey: '', // 链接key，用于打点上报
            ico: require('@assets/image/officialWebStore/beast/welfare-ico-3.png'), //ico
            defaultLang: 'en-US', // 文案默认语言
            text: {
              // 文案配置
              'en-US': 'Christmas Chart-Topping Rewards'
            }
          });
        }

        return arr;
      })(),
      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/MechaDomination/', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        },
        {
          link: 'https://discord.gg/NVDjMkCb', // 跳转链接
          linkKey: 'discord', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-discord-ico.png'), //ico
          btnColor: '#6665d2', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Discord'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/beast/default-product.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/beast/default-coin.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/beast/default-coin.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/beast/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/beast/currency-guide-1.png'),
        require('@assets/image/officialWebStore/beast/currency-guide-2.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#b17f6a', //渐变按钮左
      gradientBtnRight: '#e2ab94', //渐变按钮右
      border: '#dddddd', //所有框体边框色
      borderActive: '#b17f6a', //所有框体边框色高亮
      borderActiveShade: '#ecd9cb', // 所有框体边框高亮阴影色
      btnBg: '#b17f6a', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#ecd9cb', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#ffb330', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    isShowPreRightsPopup: true, // 是否展示上线前弹窗
    offLineTime: '2025-01-02T23:59:59Z', // 公告下线时间后不再弹窗时间，需加上时区信息
    offLineDate: {
      'zh-TW': '2025-01-02 23:59:59 (UTC)',
      'zh-CN': '2025-01-02 23:59:59 (UTC)',
      'vi-VN': '23:59:59 (UTC) ngày 02/01/2025',
      'tr-TR': '02/01/2025 23.59.59 (UTC)',
      'th-TH': '2025-01-02 เวลา 23:59:59 น.(UTC)',
      'ru-RU': '2025/01/02 23:59:59 (UTC)',
      'pt-PT': '02/01/2025 23:59:59 (UTC)',
      'pl-PL': '2025/01/02 23:59:59 (UTC)',
      'ko-KR': '2025-01-02 23:59:59(UTC)',
      'ja-JP': '2025 年 1 月 2 日 23:59:59(UTC)',
      'it-IT': '02/01/2025 23:59:59 (UTC)',
      'id-ID': '2/1/2025 23:59:59 (UTC)',
      'fr-FR': '02/01/2025 23:59:59 (UTC)',
      'es-ES': '02/01/2025 23:59:59 (UTC)',
      'en-US': '2025/01/02 23:59:59 (UTC)',
      'de-DE': '02.01.2025, 23:59:59 Uhr (UTC)',
      'ar-SA': '02-01-2025 23:59:59 (UTC)'
    }, // 配置公告下线时间
    preRightsPopupLink: '', // 上线前弹窗链接
    isOnlineRightsCenter: true, // 是否上线权益中心
    rightsCenterLink: `//auto-page.${mainHost}/jsvip01/?cid=pay&scid=activitylist`, // 权益中心链接
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 日本旧时光
  321: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'swsjp',
    //游戏名
    gameName: '下町ドリーム',
    //页面配置
    pageInfo: {
      pageTitle: '下町ドリーム-心に染みる人情物語', // 页面title
      pageIco: require('@assets/image/officialWebStore/swsjp/yeqian.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/swsjp/swsjp-ico.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/swsjp/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo
    logo: {
      'en-US': require('@assets/image/officialWebStore/swsjp/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/swsjp/banner.png'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/tmslg/banner.png'), // 图片
        //     link: '//www.baidu.com' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: false, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: '下町ドリーム', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      // 当前vip未打开，打开的时候请配置具体奖励规则
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              text: '11%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              text: '13%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              text: '11%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              text: '11%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swsjp/vip-coupon.png'),
              text: '13%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/swsjp/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـ下町ドリーム  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom 下町ドリーム-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the 下町ドリーム Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de 下町ドリーム. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de 下町ドリーム. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          '下町ドリーム bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional 下町ドリーム  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  下町ドリーム  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal 下町ドリーム Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『下町ドリーム』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『下町ドリーム』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          '下町ドリーム 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 下町ドリーム 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 下町ドリーム 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny 下町ドリーム. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações 下町ドリーム. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «下町ドリーム». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน 下町ドリーム อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน 下町ドリーム ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน 下町ドリーム เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya 下町ドリーム Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành 下町ドリーム có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành 下町ドリーム chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành 下町ドリーム xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          '下町ドリーム 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 下町ドリーム 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 下町ドリーム 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          '下町ドリーム 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 下町ドリーム 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 下町ドリーム 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: '//www.baidu.com', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/welfare-ico-1.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Share for Gifts',
        //     'zh-CN': '分享活动'
        //   }
        // },
      ],

      // 社群列表
      communityList: [
        {
          link: 'https://twitter.com/shitamachi_jp', // 跳转链接
          linkKey: 'twitter', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-twitter-ico.png'), //ico
          btnColor: '#000000', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'X'
          }
        },
        {
          link: `https://jp.${mainHost}/swsjp/index.html`, // 跳转链接
          linkKey: 'homepage', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-website-ico.png'), //ico
          btnColor: '#ffa200', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Game Website'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/swsjp/default-product.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/swsjp/default-coin.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/swsjp/default-voucher.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/swsjp/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/swsjp/currency-guide-1.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#a46f60', //渐变按钮左
      gradientBtnRight: '#c8988a', //渐变按钮右
      border: '#dddddd', //所有框体边框色
      borderActive: '#b17f6a', //所有框体边框色高亮
      borderActiveShade: '#f3e1d5', // 所有框体边框高亮阴影色
      btnBg: '#a46f60', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#f3e1d5', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#ffb330', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 台湾旧时光
  307: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'swtwt',
    //游戏名
    gameName: '營業中！舊時光商店',
    //页面配置
    pageInfo: {
      pageTitle: '營業中！舊時光商店', // 页面title
      pageIco: require('@assets/image/officialWebStore/swtwt/yeqian.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/swtwt/swsjp-ico.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/swtwt/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo
    logo: {
      'en-US': require('@assets/image/officialWebStore/swtwt/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/swtwt/banner.png'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/tmslg/banner.png'), // 图片
        //     link: '//www.baidu.com' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: false, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: '營業中！舊時光商店', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      // 当前vip未打开，打开的时候请配置具体奖励规则
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              text: '11%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              text: '13%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              text: '11%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              text: '11%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/swtwt/vip-coupon.png'),
              text: '13%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/swtwt/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـ營業中！舊時光商店  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom 營業中！舊時光商店-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the 營業中！舊時光商店 Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de 營業中！舊時光商店. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de 營業中！舊時光商店. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          '營業中！舊時光商店 bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional 營業中！舊時光商店  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  營業中！舊時光商店  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal 營業中！舊時光商店 Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『營業中！舊時光商店』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『營業中！舊時光商店』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          '營業中！舊時光商店 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 營業中！舊時光商店 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 營業中！舊時光商店 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny 營業中！舊時光商店. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações 營業中！舊時光商店. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «營業中！舊時光商店». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน 營業中！舊時光商店 อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน 營業中！舊時光商店 ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน 營業中！舊時光商店 เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya 營業中！舊時光商店 Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành 營業中！舊時光商店 có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành 營業中！舊時光商店 chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành 營業中！舊時光商店 xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          '營業中！舊時光商店 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 營業中！舊時光商店 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 營業中！舊時光商店 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          '營業中！舊時光商店 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 營業中！舊時光商店 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 營業中！舊時光商店 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: '//www.baidu.com', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/welfare-ico-1.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Share for Gifts',
        //     'zh-CN': '分享活动'
        //   }
        // },
      ],

      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/VintageShops.M/ ', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        },
        {
          link: 'https://www.blancozone.com/swtwt/index.html ', // 跳转链接
          linkKey: 'homepage', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-website-ico.png'), //ico
          btnColor: '#ffa200', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Game Website'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/swtwt/default-product.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/swtwt/default-coin.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/swtwt/default-voucher.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/swtwt/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/swtwt/currency-guide-1.jpg')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#a46f60', //渐变按钮左
      gradientBtnRight: '#c8988a', //渐变按钮右
      border: '#dddddd', //所有框体边框色
      borderActive: '#b17f6a', //所有框体边框色高亮
      borderActiveShade: '#f3e1d5', // 所有框体边框高亮阴影色
      btnBg: '#a46f60', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#f3e1d5', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#ffb330', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 全球侏罗纪军团
  331: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'zljslg',
    //游戏名
    gameName: 'Primal Conquest: Dino Era',
    //页面配置
    pageInfo: {
      pageTitle: 'Primal Conquest Official top-up', // 页面title
      keywords: "Primal Conquest: Dino Era's top-up, Official top-up, topup", // 页面seo关键字
      description: 'Primal Conquest Official top-up', // 页面seo描述
      pageIco: require('@assets/image/officialWebStore/zljslg/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/zljslg/icon331.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/zljslg/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/zljslg/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/zljslg/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        'en-US': (() => {
          const arr = [
            {
              img: require('@assets/image/officialWebStore/zljslg/banner-1.png'), // 图片
              link: `//auto-page.${mainHost}/zljlc01/` // 跳转
            }
          ];
          if (new Date().toISOString() < '2025-11-30T23:59:59Z') {
            arr.unshift({
              img: require('@assets/image/officialWebStore/zljslg/banner-2.png'), // 图片
              link: `//auto-page.${mainHost}/zljcb04/` // 跳转
            });
          }
          if (new Date().toISOString() < '2025-08-24T23:59:59Z') {
            arr.unshift({
              img: require('@assets/image/officialWebStore/zljslg/banner-3.jpg'), // 图片
              link: `https://auto-page.${mainHost}/zljxf01/` // 跳转
            });
          }

          return arr;
        })()
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Primal Conquest: Dino Era', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '20', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '200',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '500',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              text: '11%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              text: '13%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              text: '11%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '2000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              text: '11%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/zljslg/vip-coupon.png'),
              text: '13%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/zljslg/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـPrimal Conquest: Dino Era  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Primal Conquest: Dino Era-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the Primal Conquest: Dino Era Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Primal Conquest: Dino Era. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Primal Conquest: Dino Era. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'Primal Conquest: Dino Era bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Primal Conquest: Dino Era  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  Primal Conquest: Dino Era  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Primal Conquest: Dino Era Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『Primal Conquest: Dino Era』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『Primal Conquest: Dino Era』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          'Primal Conquest: Dino Era 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 Primal Conquest: Dino Era 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 Primal Conquest: Dino Era 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Primal Conquest: Dino Era. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Primal Conquest: Dino Era. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Primal Conquest: Dino Era». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน Primal Conquest: Dino Era อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน Primal Conquest: Dino Era ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน Primal Conquest: Dino Era เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya Primal Conquest: Dino Era Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành Primal Conquest: Dino Era có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Primal Conquest: Dino Era chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Primal Conquest: Dino Era xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'Primal Conquest: Dino Era 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Primal Conquest: Dino Era 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 Primal Conquest: Dino Era 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'Primal Conquest: Dino Era 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Primal Conquest: Dino Era 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 Primal Conquest: Dino Era 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: (() => {
        const arr = [
          {
            link: `//auto-page.${mainHost}/zljlc01/`, // 跳转链接
            linkKey: '', // 链接key，用于打点上报
            ico: require('@assets/image/officialWebStore/zljslg/welfare-ico-1.png'), //ico
            defaultLang: 'en-US', // 文案默认语言
            text: {
              // 文案配置
              'en-US': 'Top-up Reward！'
            }
          }
        ];
        if (new Date().toISOString() < '2025-08-07T23:59:59Z') {
          arr.unshift({
            link: `//auto-page.${mainHost}/zljcb03/`, // 跳转链接
            linkKey: '', // 链接key，用于打点上报
            ico: require('@assets/image/officialWebStore/zljslg/welfare-ico-2.png'), //ico
            defaultLang: 'en-US', // 文案默认语言
            text: {
              // 文案配置
              'en-US': 'Rank Rush Gifts'
            }
          });
        }
        return arr;
      })(),
      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/PrimalConquestDinoEra', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        },
        {
          link: 'https://discord.gg/UgBqSKv7a2', // 跳转链接
          linkKey: 'discord', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-discord-ico.png'), //ico
          btnColor: '#6665d2', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Discord'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/zljslg/defaultProductIco2.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/zljslg/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/zljslg/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/zljslg/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/zljslg/zljslg-currency-guide-1.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#7a9d1e', //渐变按钮左
      gradientBtnRight: '#a2c644', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#7a9d1e', //所有框体边框色高亮
      borderActiveShade: '#e8eccb', // 所有框体边框高亮阴影色
      btnBg: '#7a9d1e', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#e8eccb', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 是否自定义商品分类名称、ico
    isCustomProductType: true,
    productType: {
      typeall: {
        order: 1,
        img: require('@assets/image/officialWebStore/zljslg/productType/typeall.png')
      },
      type1: {
        order: 2,
        img: require('@assets/image/officialWebStore/zljslg/productType/ico_libao.png')
      },
      type2: {
        order: 102,
        img: require('@assets/image/officialWebStore/zljslg/productType/ico_biaoqianlongchong.png')
      },
      type3: {
        order: 103,
        img: require('@assets/image/officialWebStore/zljslg/productType/ico_biaoqiajunshi.png')
      },
      type5: {
        order: 104,
        img: require('@assets/image/officialWebStore/zljslg/productType/ico_biaoqianbaoshi.png')
      },
      type6: {
        order: 107,
        img: require('@assets/image/officialWebStore/zljslg/productType/ico_biaoqiannvwusheng.png')
      },
      type7: {
        order: 108,
        img: require('@assets/image/officialWebStore/zljslg/productType/ico_biaoqianziyuan.png')
      },
      type8: {
        order: 109,
        img: require('@assets/image/officialWebStore/zljslg/productType/ico_biaoqianjianzaoyanfa.png')
      },
      type9: {
        order: 110,
        img: require('@assets/image/officialWebStore/zljslg/productType/ico_biaoqianbaowu.png')
      },
      type11: {
        order: 113,
        img: require('@assets/image/officialWebStore/zljslg/productType/ico_biaoqianshuijing.png')
      },
      type12: {
        order: 105,
        img: require('@assets/image/officialWebStore/zljslg/productType/ico_biaoqianlonghunshi.png')
      },
      type13: {
        order: 106,
        img: require('@assets/image/officialWebStore/zljslg/productType/ico_biaoqianzhanwen.png')
      },
      type15: {
        order: 111,
        img: require('@assets/image/officialWebStore/zljslg/productType/ico_shenqi.png')
      },
      type16: {
        order: 3,
        img: require('@assets/image/officialWebStore/zljslg/productType/ico_zhongjidajiang.png')
      },
      type999: {
        order: 0,
        img: require('@assets/image/officialWebStore/zljslg/productType/ico_daijinquan.png')
      },
      type9999: {
        order: 101,
        img: require('@assets/image/officialWebStore/zljslg/productType/ico_chaozhilibao.png')
      },
      type10000: {
        order: 5,
        img: require('@assets/image/officialWebStore/zljslg/productType/ico_fulizhongxin.png')
      },
      type10001: {
        order: 4,
        img: require('@assets/image/officialWebStore/zljslg/productType/ico_yuemaiyuezhi.png')
      },
      typeother: {
        order: 9999,
        img: require('@assets/image/officialWebStore/zljslg/productType/typeother.png')
      },
      type25: {
        order: 112,
        img: require('@assets/image/officialWebStore/zljslg/productType/type25.png')
      }
    },
    //  商品分类翻译
    productTypeLang: {
      'ar-SA': {
        type1: 'Daily Sale',
        type2: 'Saurpet',
        type3: 'Combat Eqpt.',
        type5: 'Gem',
        type6: 'Sauroi',
        type7: 'Resource',
        type8: 'Build & Research Training',
        type9: 'Rare Items',
        type11: 'Crystal',
        type12: 'Soulgem',
        type13: 'Glyph',
        type15: 'Saurpet Totem',
        type16: 'Ultimate Prize',
        type999: 'Region Voucher',
        type9999: 'Limited Offer',
        type10000: 'Gift Center',
        type10001: 'Holiday Events',
        type25: 'Sigil'
      },
      'de-DE': {
        type1: 'Tagesangebot',
        type2: 'Saurier',
        type3: 'Kampfausrüstung',
        type5: 'Juwel',
        type6: 'Sauroi',
        type7: 'Ressourcen',
        type8: 'Bauen & Forschen Training',
        type9: 'Seltene Gegenstände',
        type11: 'Kristall',
        type12: 'Seelenstein',
        type13: 'Glyphe',
        type15: 'Saurier-Totem',
        type16: 'Ultimativer Preis',
        type999: 'Regionsgutschein',
        type9999: 'Begrenztes Angebot',
        type10000: 'Geschenkzentrum',
        type10001: 'Feiertag Events',
        type25: 'Siegel'
      },
      'en-US': {
        type1: 'Daily Sale',
        type2: 'Saurpet',
        type3: 'Combat Eqpt.',
        type5: 'Gem',
        type6: 'Sauroi',
        type7: 'Resource',
        type8: 'Build & Research Training',
        type9: 'Rare Items',
        type11: 'Crystal',
        type12: 'Soulgem',
        type13: 'Glyph',
        type15: 'Saurpet Totem',
        type16: 'Ultimate Prize',
        type999: 'Region Voucher',
        type9999: 'Limited Offer',
        type10000: 'Gift Center',
        type10001: 'Holiday Events',
        type25: 'Sigil'
      },
      'es-ES': {
        type1: 'Oferta diaria',
        type2: 'Saurigo',
        type3: 'Equipo de combate',
        type5: 'Gema',
        type6: 'Sauroi',
        type7: 'Recurso',
        type8: 'Entrenamiento de construcción e investigación',
        type9: 'Objetos raros',
        type11: 'Cristal',
        type12: 'Gema de alma',
        type13: 'Glifo',
        type15: 'Tótem de Saurigo',
        type16: 'Premio definitivo',
        type999: 'Cupón de región',
        type9999: 'Oferta limitada',
        type10000: 'Centro de regalos',
        type10001: 'Eventos festivos',
        type25: 'Sello'
      },
      'fr-FR': {
        type1: 'Offre quotidienne',
        type2: 'Minidino',
        type3: 'Éqpt. de combat',
        type5: 'Gemme',
        type6: 'Sauroi',
        type7: 'Ressource',
        type8: 'Construction & recherche & entraînement',
        type9: 'Objets rares',
        type11: 'Cristal',
        type12: "Gemme d'âme",
        type13: 'Glyphe',
        type15: 'Totem de minidino',
        type16: 'Prix ultime',
        type999: 'Coupon régional',
        type9999: 'Offre limitée',
        type10000: 'Centre des cadeaux',
        type10001: 'Évènements de fête',
        type25: 'Sceau'
      },
      'id-ID': {
        type1: 'Daily Sale',
        type2: 'Saurpet',
        type3: 'Combat Eqpt.',
        type5: 'Gem',
        type6: 'Sauroi',
        type7: 'Resource',
        type8: 'Build & Research Training',
        type9: 'Rare Items',
        type11: 'Crystal',
        type12: 'Soulgem',
        type13: 'Glyph',
        type15: 'Saurpet Totem',
        type16: 'Ultimate Prize',
        type999: 'Region Voucher',
        type9999: 'Limited Offer',
        type10000: 'Gift Center',
        type10001: 'Holiday Events',
        type25: 'Sigil'
      },
      'it-IT': {
        type1: 'Daily Sale',
        type2: 'Saurpet',
        type3: 'Combat Eqpt.',
        type5: 'Gem',
        type6: 'Sauroi',
        type7: 'Resource',
        type8: 'Build & Research Training',
        type9: 'Rare Items',
        type11: 'Crystal',
        type12: 'Soulgem',
        type13: 'Glyph',
        type15: 'Saurpet Totem',
        type16: 'Ultimate Prize',
        type999: 'Region Voucher',
        type9999: 'Limited Offer',
        type10000: 'Gift Center',
        type10001: 'Holiday Events',
        type25: 'Sigil'
      },
      'ja-JP': {
        type1: 'デイリー特典',
        type2: '恐竜',
        type3: '戦闘装備',
        type5: 'ジェム',
        type6: '恐竜王',
        type7: '資源',
        type8: '建築・開発・訓練',
        type9: '貴重な商品',
        type11: '水晶',
        type12: '魂石',
        type13: '戦紋',
        type15: '恐竜トーテム',
        type16: '究極大賞',
        type999: '王国金券',
        type9999: '限定特別供給',
        type10000: '特典センター',
        type10001: '祝日イベント',
        type25: 'シンボル'
      },
      'ko-KR': {
        type1: '일일 특혜',
        type2: '공룡',
        type3: '전투 장비',
        type5: '보석',
        type6: '공룡왕',
        type7: '자원',
        type8: '건설 연구 훈련',
        type9: '희귀 아이템',
        type11: '수정',
        type12: '영혼석',
        type13: '기호',
        type15: '공룡&토템',
        type16: '최종 보상',
        type999: '왕국 상품권',
        type9999: '한정 공급',
        type10000: '혜택 센터',
        type10001: '기념일 이벤트',
        type25: '표식'
      },
      'pl-PL': {
        type1: 'Daily Sale',
        type2: 'Saurpet',
        type3: 'Combat Eqpt.',
        type5: 'Gem',
        type6: 'Sauroi',
        type7: 'Resource',
        type8: 'Build & Research Training',
        type9: 'Rare Items',
        type11: 'Crystal',
        type12: 'Soulgem',
        type13: 'Glyph',
        type15: 'Saurpet Totem',
        type16: 'Ultimate Prize',
        type999: 'Region Voucher',
        type9999: 'Limited Offer',
        type10000: 'Gift Center',
        type10001: 'Holiday Events',
        type25: 'Sigil'
      },
      'pt-PT': {
        type1: 'Daily Sale',
        type2: 'Saurpet',
        type3: 'Combat Eqpt.',
        type5: 'Gem',
        type6: 'Sauroi',
        type7: 'Resource',
        type8: 'Build & Research Training',
        type9: 'Rare Items',
        type11: 'Crystal',
        type12: 'Soulgem',
        type13: 'Glyph',
        type15: 'Saurpet Totem',
        type16: 'Ultimate Prize',
        type999: 'Region Voucher',
        type9999: 'Limited Offer',
        type10000: 'Gift Center',
        type10001: 'Holiday Events',
        type25: 'Sigil'
      },
      'ru-RU': {
        type1: 'Diskon Harian',
        type2: 'Dinopet',
        type3: 'Gear Kombat',
        type5: 'Permata',
        type6: 'Sauroi',
        type7: 'Sumber Daya',
        type8: 'Latihan Konstruksi & Riset',
        type9: 'Item Langka',
        type11: 'Kristal',
        type12: 'Batu Roh',
        type13: 'Glyph',
        type15: 'Totem Dinopet',
        type16: 'Hadiah Super',
        type999: 'Voucer Region',
        type9999: 'Penawaran Terbatas',
        type10000: 'Pusat Benefit',
        type10001: 'Event Liburan',
        type25: 'Символ'
      },
      'th-TH': {
        type1: 'Daily Sale',
        type2: 'Saurpet',
        type3: 'Combat Eqpt.',
        type5: 'Gem',
        type6: 'Sauroi',
        type7: 'Resource',
        type8: 'Build & Research Training',
        type9: 'Rare Items',
        type11: 'Crystal',
        type12: 'Soulgem',
        type13: 'Glyph',
        type15: 'Saurpet Totem',
        type16: 'Ultimate Prize',
        type999: 'Region Voucher',
        type9999: 'Limited Offer',
        type10000: 'Gift Center',
        type10001: 'Holiday Events',
        type25: 'Sigil'
      },
      'tr-TR': {
        type1: 'Daily Sale',
        type2: 'Saurpet',
        type3: 'Combat Eqpt.',
        type5: 'Gem',
        type6: 'Sauroi',
        type7: 'Resource',
        type8: 'Build & Research Training',
        type9: 'Rare Items',
        type11: 'Crystal',
        type12: 'Soulgem',
        type13: 'Glyph',
        type15: 'Saurpet Totem',
        type16: 'Ultimate Prize',
        type999: 'Region Voucher',
        type9999: 'Limited Offer',
        type10000: 'Gift Center',
        type10001: 'Holiday Events',
        type25: 'Sigil'
      },
      'vi-VN': {
        type1: 'Ưu Đãi Ngày',
        type2: 'Pet',
        type3: 'Trang Bị Chiến Đấu',
        type5: 'Đá',
        type6: 'Vua Thú',
        type7: 'Tài Nguyên',
        type8: 'Xây Dựng Nghiên Cứu Huấn Luyện',
        type9: 'Vật Phẩm Hiếm',
        type11: 'Pha Lê',
        type12: 'Đá Hồn',
        type13: 'Chiến Văn',
        type15: 'Vật Tổ Pet',
        type16: 'Thưởng Cuối',
        type999: 'Phiếu Vương Quốc',
        type9999: 'Giới Hạn',
        type10000: 'Khu Phúc Lợi',
        type10001: 'Hoạt Động Lễ',
        type25: 'Ấn Ký'
      },
      'zh-CN': {
        type1: '每日特惠',
        type2: '龙宠',
        type3: '战斗装备',
        type5: '宝石',
        type6: '龙王',
        type7: '资源',
        type8: '建造研发训练',
        type9: '稀缺商品',
        type11: '水晶',
        type12: '魂石',
        type13: '战纹',
        type15: '龙宠图腾',
        type16: '终极大奖',
        type999: '王国金券',
        type9999: '限量特供',
        type10000: '福利中心',
        type10001: '节日活动',
        type25: '印记'
      },
      'zh-TW': {
        type1: '每日特惠',
        type2: '龍寵',
        type3: '戰鬥裝備',
        type5: '寶石',
        type6: '龍王',
        type7: '資源',
        type8: '建造研發訓練',
        type9: '稀缺商品',
        type11: '水晶',
        type12: '魂石',
        type13: '戰紋',
        type15: '龍寵圖騰',
        type16: '終極大獎',
        type999: '王國金券',
        type9999: '限量特供',
        type10000: '福利中心',
        type10001: '節日活動',
        type25: '印記'
      }
    },
    isShowPreRightsPopup: true, // 是否展示上线前弹窗
    offLineTime: '2025-03-21T23:59:59+09:00', // 公告下线时间后不再弹窗时间，需加上时区信息
    offLineDate: {
      'zh-TW': '2025-03-21 23:59:59 (UTC)',
      'zh-CN': '2025-03-21 23:59:59 (UTC)',
      'vi-VN': '23:59:59 (UTC) ngày 21/03/2025',
      'tr-TR': '21/03/2025 23.59.59 (UTC)',
      'th-TH': '2025-03-21 เวลา 23:59:59 น.(UTC)',
      'ru-RU': '2025/03/21 23:59:59 (UTC)',
      'pt-PT': '21/03/2025 23:59:59 (UTC)',
      'pl-PL': '2025/03/21 23:59:59 (UTC)',
      'ko-KR': '2025-03-21 23:59:59(UTC)',
      'ja-JP': '2025 年 3 月 21 日 23:59:59(UTC)',
      'it-IT': '21/03/2025 23:59:59 (UTC)',
      'id-ID': '21/03/2025 23:59:59 (UTC)',
      'fr-FR': '21/03/2025 23:59:59 (UTC)',
      'es-ES': '21/03/2025 23:59:59 (UTC)',
      'en-US': '2025/03/21 23:59:59 (UTC)',
      'de-DE': '21.03.2025, 23:59:59 Uhr (UTC)',
      'ar-SA': '21/03/2025 23:59:59 (UTC)'
    }, // 配置公告下线时间
    preRightsPopupLink: '', // 上线前弹窗链接
    isOnlineRightsCenter: true, // 是否上线权益中心
    rightsCenterLink: `//auto-page.${mainHost}/zjlvip01/` // 权益中心链接
  },
  // 台港澳寻道大千
  335: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'xddq',
    //游戏名
    gameName: '小妖問道',
    //页面配置
    pageInfo: {
      pageTitle: '小妖問道 逍遙自在', // 页面title
      pageIco: require('@assets/image/officialWebStore/xddq/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/xddq/icon335.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/xddq/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/xddq/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/xddq/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/xddqsea/banner-tw.png'), // 图片
        //     link: 'https://auto-page.blancozone.com/dqzq03/' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: '小妖問道', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/xddq/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـ小妖問道  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom 小妖問道-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the 小妖問道 Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de 小妖問道. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de 小妖問道. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          '小妖問道 bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional 小妖問道  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  小妖問道  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal 小妖問道 Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『小妖問道』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『小妖問道』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          '小妖問道 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 小妖問道 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 小妖問道 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny 小妖問道. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações 小妖問道. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «小妖問道». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน 小妖問道 อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน 小妖問道 ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน 小妖問道 เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya 小妖問道 Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành 小妖問道 có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành 小妖問道 chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành 小妖問道 xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          '小妖問道 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 小妖問道 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 小妖問道 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          '小妖問道 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 小妖問道 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 小妖問道 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: '//auto-page.blancozone.com/dqzq03/', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/xddqsea/welfare-ico-3.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Mid-Autumn Giftpack',
        //     'zh-TW': '中秋贈豪禮',
        //     'ja-JP': '中秋節の豪華プレゼント',
        //     'ko-KR': '추석 선물 증정',
        //     'vi-VN': 'Quà Tặng Trung Thu'
        //   }
        // }
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/CutDownaTree.game', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/xddq/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/xddq/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/xddq/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/xddq/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/xddq/xddq-currency-guide-1.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#e5ae5d', //渐变按钮左
      gradientBtnRight: '#fdecb6', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#e5ae5d', //所有框体边框色高亮
      borderActiveShade: '#e2d2bf', // 所有框体边框高亮阴影色
      btnBg: '#e5ae5d', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#e2d2bf', // 大按钮阴影色
      productName: '#e5ae5d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {
      'en-US':
        'Purchase successful! Please keep an eye on your in-game mailbox.',
      'zh-CN': '儲值成功，請留意遊戲信件提示哦！',
      'zh-TW': '儲值成功，請留意遊戲信件提示哦！',
      'ko-KR': '충전했습니다. 게임 내 우편을 확인해주세요.',
      'ja-JP': '入金成功。ゲーム内の手紙にて確認してください！',
      'th-TH': 'เติมเงินสำเร็จ โปรดอย่าลืมเช็กอีเมลภายในเกมนะ!'
    },
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'zh-TW', // 默认语言
      resource: {
        // 'zh-TW': {
        //   close: require('@assets/image/officialWebStore/xddq/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/xddq/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/xddq/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    isShowPreRightsPopup: false, // 是否展示上线前弹窗
    offLineTime: '2024-10-18T23:59:59+09:00', // 公告下线时间后不再弹窗时间，需加上时区信息
    offLineDate: {
      'zh-TW': '2024-10-18 23:59:59 (UTC+9)',
      'zh-CN': '2024-10-18 23:59:59 (UTC+9)',
      'vi-VN': '23:59:59 (UTC+9) ngày 18/10/2024',
      'tr-TR': '18/10/2024 23.59.59 (UTC+9)',
      'th-TH': '2024-10-18 เวลา 23:59:59 น.(UTC+9)',
      'ru-RU': '2024/10/18 23:59:59 (UTC+9)',
      'pt-PT': '18/10/2024 23:59:59 (UTC+9)',
      'pl-PL': '2024/10/18 23:59:59 (UTC+9)',
      'ko-KR': '2024-10-18 23:59:59(UTC+9)',
      'ja-JP': '2024 年 10 月 18 日 23:59:59(UTC+9)',
      'it-IT': '18/10/2024 23:59:59 (UTC+9)',
      'id-ID': '18/10/2024 23:59:59 (UTC+9)',
      'fr-FR': '18/10/2024 23:59:59 (UTC+9)',
      'es-ES': '18/10/2024 23:59:59 (UTC+9)',
      'en-US': '2024/10/18 23:59:59 (UTC+9)',
      'de-DE': '18.10.2024, 23:59:59 Uhr (UTC+9)',
      'ar-SA': '18-10-2024 23:59:59 (UTC+9)'
    }, // 配置公告下线时间
    preRightsPopupLink: '', // 上线前弹窗链接
    isOnlineRightsCenter: true, // 是否上线权益中心
    rightsCenterLink: `//auto-page.${mainHost}/xddqtwvip01/?cid=${globalConfig.getHrefParam(
      'cid'
    )}&scid=${globalConfig.getHrefParam('scid')}`, // 权益中心链接
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: true,
      activityName: 'dqtwpwagift'
    },
    // 添加到桌面背景和按钮
    pwaInstallPopupBg: require('@assets/image/officialWebStore/xddq/pwa-install-popup-bg.png'),
    pwaInstallPopupBtn: require('@assets/image/officialWebStore/xddq/pwa-install-popup-btn.png'),
    pwaInstall: require('@assets/image/officialWebStore/xddq/pwa-install.png'),
    pwaInstalledAward: require('@assets/image/officialWebStore/xddq/pwa-installed-award.png')
  },
  // 韩国寻道大千
  340: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'xddqkr',
    //游戏名
    gameName: '요괴 벌목꾼: 영차영차, 보물이야 떨어져라',
    //页面配置
    pageInfo: {
      pageTitle: '요괴 벌목꾼: 영차영차, 보물이야 떨어져라', // 页面title
      pageIco: require('@assets/image/officialWebStore/xddqkr/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/xddqkr/icon340.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/xddq/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/xddqkr/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/xddq/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/xddqsea/banner-kr.png'), // 图片
        //     link: 'https://auto-page.blancozone.com/dqzq02/' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: false, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: '요괴 벌목꾼: 영차영차, 보물이야 떨어져라', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/xddq/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـ요괴 벌목꾼: 영차영차, 보물이야 떨어져라  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom 요괴 벌목꾼: 영차영차, 보물이야 떨어져라-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the 요괴 벌목꾼: 영차영차, 보물이야 떨어져라 Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de 요괴 벌목꾼: 영차영차, 보물이야 떨어져라. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de 요괴 벌목꾼: 영차영차, 보물이야 떨어져라. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          '요괴 벌목꾼: 영차영차, 보물이야 떨어져라 bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional 요괴 벌목꾼: 영차영차, 보물이야 떨어져라  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  요괴 벌목꾼: 영차영차, 보물이야 떨어져라  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal 요괴 벌목꾼: 영차영차, 보물이야 떨어져라 Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『요괴 벌목꾼: 영차영차, 보물이야 떨어져라』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『요괴 벌목꾼: 영차영차, 보물이야 떨어져라』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          '요괴 벌목꾼: 영차영차, 보물이야 떨어져라 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 요괴 벌목꾼: 영차영차, 보물이야 떨어져라 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 요괴 벌목꾼: 영차영차, 보물이야 떨어져라 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny 요괴 벌목꾼: 영차영차, 보물이야 떨어져라. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações 요괴 벌목꾼: 영차영차, 보물이야 떨어져라. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «요괴 벌목꾼: 영차영차, 보물이야 떨어져라». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน 요괴 벌목꾼: 영차영차, 보물이야 떨어져라 อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน 요괴 벌목꾼: 영차영차, 보물이야 떨어져라 ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน 요괴 벌목꾼: 영차영차, 보물이야 떨어져라 เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya 요괴 벌목꾼: 영차영차, 보물이야 떨어져라 Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành 요괴 벌목꾼: 영차영차, 보물이야 떨어져라 có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành 요괴 벌목꾼: 영차영차, 보물이야 떨어져라 chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Puzzles & Conquest xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          '요괴 벌목꾼: 영차영차, 보물이야 떨어져라 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 요괴 벌목꾼: 영차영차, 보물이야 떨어져라 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 요괴 벌목꾼: 영차영차, 보물이야 떨어져라 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          '요괴 벌목꾼: 영차영차, 보물이야 떨어져라 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 요괴 벌목꾼: 영차영차, 보물이야 떨어져라 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 요괴 벌목꾼: 영차영차, 보물이야 떨어져라 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: '//auto-page.blancozone.com/dqzq02/', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/xddqsea/welfare-ico-3.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Mid-Autumn Giftpack',
        //     'zh-TW': '中秋贈豪禮',
        //     'ja-JP': '中秋節の豪華プレゼント',
        //     'ko-KR': '추석 선물 증정',
        //     'vi-VN': 'Quà Tặng Trung Thu'
        //   }
        // },
        {
          link: '//auto-page.blancozone.com/xdaq10/', // 跳转链接
          linkKey: '', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/xddqkr/welfare-ico-1.png'), //ico
          defaultLang: 'ko-KR', // 文案默认语言
          text: {
            // 文案配置
            'en-US': 'Total Top-Up Gift',
            'zh-CN': '累计充值领好礼',
            'zh-TW': '累計儲值領好禮',
            'ja-JP': '合計購入額で報酬GET',
            'ko-KR': '누적 충전 선물',
            'th-TH': 'เติมเงินสะสม รับรางวัล'
          }
        }
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://game.naver.com/lounge/ghostlogger/home', // 跳转链接
          linkKey: 'lounge', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-lounge-ico.png'), //ico
          btnColor: '#62d56f', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Lounge'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/xddq/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/xddq/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/xddq/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/xddq/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/xddqkr/xddqkr-currency-guide-1.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#e5ae5d', //渐变按钮左
      gradientBtnRight: '#fdecb6', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#e5ae5d', //所有框体边框色高亮
      borderActiveShade: '#e2d2bf', // 所有框体边框高亮阴影色
      btnBg: '#e5ae5d', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#e2d2bf', // 大按钮阴影色
      productName: '#e5ae5d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {
      'en-US':
        'Purchase successful! Please keep an eye on your in-game mailbox.',
      'zh-CN': '儲值成功，請留意遊戲信件提示哦！',
      'zh-TW': '儲值成功，請留意遊戲信件提示哦！',
      'ko-KR': '충전했습니다. 게임 내 우편을 확인해주세요.',
      'ja-JP': '入金成功。ゲーム内の手紙にて確認してください！',
      'th-TH': 'เติมเงินสำเร็จ โปรดอย่าลืมเช็กอีเมลภายในเกมนะ!'
    },
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    isShowPreRightsPopup: false, // 是否展示上线前弹窗
    offLineTime: '2024-09-18T23:59:59+09:00', // 公告下线时间后不再弹窗时间，需加上时区信息
    offLineDate: {
      'zh-TW': '2024-09-18 23:59:59 (UTC+9)',
      'zh-CN': '2024-09-18 23:59:59 (UTC+9)',
      'vi-VN': '23:59:59 (UTC+9) ngày 18/09/2024',
      'tr-TR': '18/09/2024 23.59.59 (UTC+9)',
      'th-TH': '2024-09-18 เวลา 23:59:59 น.(UTC+9)',
      'ru-RU': '2024/09/18 23:59:59 (UTC+9)',
      'pt-PT': '18/09/2024 23:59:59 (UTC+9)',
      'pl-PL': '2024/09/18 23:59:59 (UTC+9)',
      'ko-KR': '2024-09-18 23:59:59(UTC+9)',
      'ja-JP': '2024 年 9 月 18 日 23:59:59(UTC+9)',
      'it-IT': '18/09/2024 23:59:59 (UTC+9)',
      'id-ID': '18/9/2024 23:59:59 (UTC+9)',
      'fr-FR': '18/09/2024 23:59:59 (UTC+9)',
      'es-ES': '18/09/2024 23:59:59 (UTC+9)',
      'en-US': '2024/09/18 23:59:59 (UTC+9)',
      'de-DE': '18.09.2024, 23:59:59 Uhr (UTC+9)',
      'ar-SA': '18-09-2024 23:59:59 (UTC+9)'
    }, // 配置公告下线时间
    preRightsPopupLink: '', // 上线前弹窗链接
    isOnlineRightsCenter: true, // 是否上线权益中心
    rightsCenterLink: `//auto-page.${mainHost}/xddqkovip01/?cid=pay&scid=activitylist`, // 权益中心链接
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: true,
      activityName: 'dqkrpwagift'
    },
    // 添加到桌面背景和按钮
    pwaInstallPopupBg: require('@assets/image/officialWebStore/xddq/pwa-install-popup-bg.png'),
    pwaInstallPopupBtn: require('@assets/image/officialWebStore/xddq/pwa-install-popup-btn.png'),
    pwaInstall: require('@assets/image/officialWebStore/xddq/pwa-install.png'),
    pwaInstalledAward: require('@assets/image/officialWebStore/xddq/pwa-installed-award.png')
  },
  // 日本寻道大千
  337: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'xddqjp',
    //游戏名
    gameName: '妖遊記 トントン名人になれ',
    //页面配置
    pageInfo: {
      pageTitle: '妖遊記 トントン名人になれ', // 页面title
      pageIco: require('@assets/image/officialWebStore/xddqjp/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/xddqjp/icon337.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/xddq/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/xddqjp/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/xddq/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/xddqsea/banner-jp.png'), // 图片
        //     link: `https://auto-page.${mainHost}/dqzq01/` // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: '妖遊記 トントン名人になれ', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/xddq/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـ妖遊記 トントン名人になれ  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom 妖遊記 トントン名人になれ-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the 妖遊記 トントン名人になれ Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de 妖遊記 トントン名人になれ. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de 妖遊記 トントン名人になれ. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          '妖遊記 トントン名人になれ bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional 妖遊記 トントン名人になれ  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  妖遊記 トントン名人になれ  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal 妖遊記 トントン名人になれ Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『妖遊記 トントン名人になれ』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『妖遊記 トントン名人になれ』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          '妖遊記 トントン名人になれ 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 妖遊記 トントン名人になれ 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 妖遊記 トントン名人になれ 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny 妖遊記 トントン名人になれ. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações 妖遊記 トントン名人になれ. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «妖遊記 トントン名人になれ». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน 妖遊記 トントン名人になれ อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน 妖遊記 トントン名人になれ ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน 妖遊記 トントン名人になれ เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya 妖遊記 トントン名人になれ Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành 妖遊記 トントン名人になれ có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành 妖遊記 トントン名人になれ chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành 妖遊記 トントン名人になれ xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          '妖遊記 トントン名人になれ 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 妖遊記 トントン名人になれ 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 妖遊記 トントン名人になれ 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          '妖遊記 トントン名人になれ 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 妖遊記 トントン名人になれ 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 妖遊記 トントン名人になれ 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: `//auto-page.${mainHost}/dqzq01/`, // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/xddqsea/welfare-ico-3.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Mid-Autumn Giftpack',
        //     'zh-TW': '中秋贈豪禮',
        //     'ja-JP': '中秋節の豪華プレゼント',
        //     'ko-KR': '추석 선물 증정',
        //     'vi-VN': 'Quà Tặng Trung Thu'
        //   }
        // },
        {
          link: `//auto-page.${mainHost}/xdaq05/`, // 跳转链接
          linkKey: '', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/xddqjp/welfare-ico-1.png'), //ico
          defaultLang: 'ja-JP', // 文案默认语言
          text: {
            // 文案配置
            'en-US': 'Total Top-Up Gift',
            'zh-CN': '累计充值领好礼',
            'zh-TW': '累計儲值領好禮',
            'ja-JP': '合計購入額で報酬GET',
            'ko-KR': '누적 충전 선물',
            'th-TH': 'เติมเงินสะสม รับรางวัล'
          }
        }
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://twitter.com/CutDownaTree1', // 跳转链接
          linkKey: 'twitter', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-twitter-ico.png'), //ico
          btnColor: '#000000', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'X'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/xddq/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/xddq/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/xddq/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/xddq/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/xddqjp/xddqjp-currency-guide-1.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#e5ae5d', //渐变按钮左
      gradientBtnRight: '#fdecb6', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#e5ae5d', //所有框体边框色高亮
      borderActiveShade: '#e2d2bf', // 所有框体边框高亮阴影色
      btnBg: '#e5ae5d', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#e2d2bf', // 大按钮阴影色
      productName: '#e5ae5d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {
      'en-US':
        'Purchase successful! Please keep an eye on your in-game mailbox.',
      'zh-CN': '儲值成功，請留意遊戲信件提示哦！',
      'zh-TW': '儲值成功，請留意遊戲信件提示哦！',
      'ko-KR': '충전했습니다. 게임 내 우편을 확인해주세요.',
      'ja-JP': '入金成功。ゲーム内の手紙にて確認してください！',
      'th-TH': 'เติมเงินสำเร็จ โปรดอย่าลืมเช็กอีเมลภายในเกมนะ!'
    },
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    isShowPreRightsPopup: true, // 是否展示上线前弹窗
    offLineTime: '2025-04-02T23:59:59+09:00', // 公告下线时间后不再弹窗时间，需加上时区信息
    offLineDate: {
      'zh-TW': '2025-04-02 23:59:59 (UTC+9)',
      'zh-CN': '2025-04-02 23:59:59 (UTC+9)',
      'vi-VN': '23:59:59 (UTC+9) ngày 02/04/2025',
      'tr-TR': '02/04/2025 23.59.59 (UTC+9)',
      'th-TH': '2025-04-02 เวลา 23:59:59 น.(UTC+9)',
      'ru-RU': '2025/04/02 23:59:59 (UTC+9)',
      'pt-PT': '02/04/2025 23:59:59 (UTC+9)',
      'pl-PL': '2025/04/02 23:59:59 (UTC+9)',
      'ko-KR': '2025-04-02 23:59:59(UTC+9)',
      'ja-JP': '2025 年 4 月 2 日 23:59:59(UTC+9)',
      'it-IT': '02/04/2025 23:59:59 (UTC+9)',
      'id-ID': '02/04/2025 23:59:59 (UTC+9)',
      'fr-FR': '02/04/2025 23:59:59 (UTC+9)',
      'es-ES': '02/04/2025 23:59:59 (UTC+9)',
      'en-US': '02/04/2025 23:59:59 (UTC+9)',
      'de-DE': '02.04.2025, 23:59:59 Uhr (UTC+9)',
      'ar-SA': '02-04-2025 23:59:59 (UTC+9)'
    }, // 配置公告下线时间
    preRightsPopupLink: ``, // 上线前弹窗链接
    isOnlineRightsCenter:
      Date.now() > new Date('2025-04-02T23:59:59+09:00').getTime(), // 是否上线权益中心
    rightsCenterLink: `//auto-page.${mainHost}/xddqjpvip01/`, // 权益中心链接
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: true,
      activityName: 'dqjppwagift'
    },
    // 添加到桌面背景和按钮
    pwaInstallPopupBg: require('@assets/image/officialWebStore/xddq/pwa-install-popup-bg.png'),
    pwaInstallPopupBtn: require('@assets/image/officialWebStore/xddq/pwa-install-popup-btn.png'),
    pwaInstall: require('@assets/image/officialWebStore/xddq/pwa-install.png'),
    pwaInstalledAward: require('@assets/image/officialWebStore/xddq/pwa-installed-award.png')
  },
  // 全球寻道大千
  339: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'xddqsea',
    //游戏名
    gameName: 'Nobodys Adventure: Chop-Chop',
    //页面配置
    pageInfo: {
      pageTitle: 'Nobodys Adventure: Chop-Chop', // 页面title
      pageIco: require('@assets/image/officialWebStore/xddqsea/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/xddqsea/icon339.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/xddq/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/xddqsea/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/xddq/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/xddqsea/banner-en.png'), // 图片
        //     link: `https://auto-page.${mainHost}/dqzq04/` // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Nobodys Adventure: Chop-Chop', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/xddq/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/xddq/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـNobodys Adventure: Chop-Chop  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Nobodys Adventure: Chop-Chop-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the Nobodys Adventure: Chop-Chop Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Nobodys Adventure: Chop-Chop. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Nobodys Adventure: Chop-Chop. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'Nobodys Adventure: Chop-Chop bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Nobodys Adventure: Chop-Chop  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  Nobodys Adventure: Chop-Chop  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Nobodys Adventure: Chop-Chop Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『Nobodys Adventure: Chop-Chop』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『Nobodys Adventure: Chop-Chop』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          'Nobodys Adventure: Chop-Chop 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 Nobodys Adventure: Chop-Chop 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 Nobodys Adventure: Chop-Chop 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Nobodys Adventure: Chop-Chop. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Nobodys Adventure: Chop-Chop. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Nobodys Adventure: Chop-Chop». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน Nobodys Adventure: Chop-Chop อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน Nobodys Adventure: Chop-Chop ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน Nobodys Adventure: Chop-Chop เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya Nobodys Adventure: Chop-Chop Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành Nobodys Adventure: Chop-Chop có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Nobodys Adventure: Chop-Chop chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Nobodys Adventure: Chop-Chop xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'Nobodys Adventure: Chop-Chop 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Nobodys Adventure: Chop-Chop 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 Nobodys Adventure: Chop-Chop 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'Nobodys Adventure: Chop-Chop 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Nobodys Adventure: Chop-Chop 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 Nobodys Adventure: Chop-Chop 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: `//auto-page.${mainHost}/dqzq04/`, // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/xddqsea/welfare-ico-3.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Mid-Autumn Giftpack',
        //     'zh-TW': '中秋贈豪禮',
        //     'ja-JP': '中秋節の豪華プレゼント',
        //     'ko-KR': '추석 선물 증정',
        //     'vi-VN': 'Quà Tặng Trung Thu'
        //   }
        // },
        {
          link: `//auto-page.${mainHost}/dqseaeu_sfcz/`, // 跳转链接
          linkKey: '', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/xddqsea/welfare-ico-1.png'), //ico
          defaultLang: 'en-US', // 文案默认语言
          text: {
            // 文案配置
            'en-US': 'Total Top-Up Gift',
            'zh-CN': '累计充值领好礼',
            'zh-TW': '累計儲值領好禮',
            'ja-JP': '合計購入額で報酬GET',
            'ko-KR': '누적 충전 선물',
            'th-TH': 'เติมเงินสะสม รับรางวัล'
          }
        }
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/profile.php?id=61552410028677', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/xddq/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/xddq/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/xddq/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/xddq/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/xddqsea/xddqsea-currency-guide-en.png')
      ],
      'th-TH': [
        require('@assets/image/officialWebStore/xddqsea/xddqsea-currency-guide-th.png')
      ],
      'zh-CN': [
        require('@assets/image/officialWebStore/xddqsea/xddqsea-currency-guide-cn.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#e5ae5d', //渐变按钮左
      gradientBtnRight: '#fdecb6', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#e5ae5d', //所有框体边框色高亮
      borderActiveShade: '#e2d2bf', // 所有框体边框高亮阴影色
      btnBg: '#e5ae5d', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#e2d2bf', // 大按钮阴影色
      productName: '#e5ae5d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {
      'en-US':
        'Purchase successful! Please keep an eye on your in-game mailbox.',
      'zh-CN': '儲值成功，請留意遊戲信件提示哦！',
      'zh-TW': '儲值成功，請留意遊戲信件提示哦！',
      'ko-KR': '충전했습니다. 게임 내 우편을 확인해주세요.',
      'ja-JP': '入金成功。ゲーム内の手紙にて確認してください！',
      'th-TH': 'เติมเงินสำเร็จ โปรดอย่าลืมเช็กอีเมลภายในเกมนะ!'
    },
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    isShowPreRightsPopup: true, // 是否展示上线前弹窗
    offLineTime: '2025-04-02T23:59:59+00:00', // 公告下线时间后不再弹窗时间，需加上时区信息
    offLineDate: {
      'zh-TW': '2025-04-02 23:59:59 (UTC+0)',
      'zh-CN': '2025-04-02 23:59:59 (UTC+0)',
      'vi-VN': '23:59:59 (UTC+0) ngày 02/04/2025',
      'tr-TR': '02/04/2025 23.59.59 (UTC+0)',
      'th-TH': '2025-04-02 เวลา 23:59:59 น.(UTC+0)',
      'ru-RU': '2025/04/02 23:59:59 (UTC+0)',
      'pt-PT': '02/04/2025 23:59:59 (UTC+0)',
      'pl-PL': '2025/04/02 23:59:59 (UTC+0)',
      'ko-KR': '2025-04-02 23:59:59(UTC+0)',
      'ja-JP': '2025 年 4 月 2 日 23:59:59(UTC+0)',
      'it-IT': '02/04/2025 23:59:59 (UTC+0)',
      'id-ID': '02/04/2025 23:59:59 (UTC+0)',
      'fr-FR': '02/04/2025 23:59:59 (UTC+0)',
      'es-ES': '02/04/2025 23:59:59 (UTC+0)',
      'en-US': '02/04/2025 23:59:59 (UTC+0)',
      'de-DE': '02.04.2025, 23:59:59 Uhr (UTC+0)',
      'ar-SA': '02-04-2025 23:59:59 (UTC+0)'
    }, // 配置公告下线时间
    preRightsPopupLink: ``, // 上线前弹窗链接
    isOnlineRightsCenter:
      Date.now() > new Date('2025-04-02T23:59:59+00:00').getTime(), // 是否上线权益中心
    rightsCenterLink: `//auto-page.${mainHost}/xddqqqvip01/`, // 权益中心链接
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: true,
      activityName: 'dqglpwagift'
    },
    // 添加到桌面背景和按钮
    pwaInstallPopupBg: require('@assets/image/officialWebStore/xddq/pwa-install-popup-bg.png'),
    pwaInstallPopupBtn: require('@assets/image/officialWebStore/xddq/pwa-install-popup-btn.png'),
    pwaInstall: require('@assets/image/officialWebStore/xddq/pwa-install.png'),
    pwaInstalledAward: require('@assets/image/officialWebStore/xddq/pwa-installed-award.png')
  },
  // 越南寻道大千
  349: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'dqvn',
    //游戏名
    gameName: 'Tiểu Yêu Tầm Đạo',
    //页面配置
    pageInfo: {
      pageTitle: 'Tiểu Yêu Tầm Đạo', // 页面title
      pageIco: require('@assets/image/officialWebStore/dqvn/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/dqvn/icon349.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/dqvn/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/dqvn/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/dqvn/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/xddqsea/banner-vi.png'), // 图片
        //     link: '//auto-page.olgamevn.com/dqzd05/' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: false, // 是否开启优惠券入口
      isOpenVip: false, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Tiểu Yêu Tầm Đạo', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dqvn/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/dqvn/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـTiểu Yêu Tầm Đạo  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Tiểu Yêu Tầm Đạo-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the Tiểu Yêu Tầm Đạo Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Tiểu Yêu Tầm Đạo. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Tiểu Yêu Tầm Đạo. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'Tiểu Yêu Tầm Đạo bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Tiểu Yêu Tầm Đạo  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  Tiểu Yêu Tầm Đạo  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Tiểu Yêu Tầm Đạo Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『Tiểu Yêu Tầm Đạo』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『Tiểu Yêu Tầm Đạo』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          'Tiểu Yêu Tầm Đạo 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 Tiểu Yêu Tầm Đạo 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 Tiểu Yêu Tầm Đạo 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Tiểu Yêu Tầm Đạo. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Tiểu Yêu Tầm Đạo. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Tiểu Yêu Tầm Đạo». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน Tiểu Yêu Tầm Đạo อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน Tiểu Yêu Tầm Đạo ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน Tiểu Yêu Tầm Đạo เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya Tiểu Yêu Tầm Đạo Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành Tiểu Yêu Tầm Đạo có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Tiểu Yêu Tầm Đạo nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Tiểu Yêu Tầm Đạo xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'Tiểu Yêu Tầm Đạo 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Tiểu Yêu Tầm Đạo 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 Tiểu Yêu Tầm Đạo 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'Tiểu Yêu Tầm Đạo 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Tiểu Yêu Tầm Đạo 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 Tiểu Yêu Tầm Đạo 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: '//auto-page.olgamevn.com/dqzd05/', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/xddqsea/welfare-ico-3.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Mid-Autumn Giftpack',
        //     'zh-TW': '中秋贈豪禮',
        //     'ja-JP': '中秋節の豪華プレゼント',
        //     'ko-KR': '추석 선물 증정',
        //     'vi-VN': 'Quà Tặng Trung Thu'
        //   }
        // }
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/tieuyeutamdao', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/dqvn/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/dqvn/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/dqvn/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/dqvn/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/dqvn/dqvn-currency-guide-1.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#e5ae5d', //渐变按钮左
      gradientBtnRight: '#fdecb6', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#e5ae5d', //所有框体边框色高亮
      borderActiveShade: '#e2d2bf', // 所有框体边框高亮阴影色
      btnBg: '#e5ae5d', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#e2d2bf', // 大按钮阴影色
      productName: '#e5ae5d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {
      'en-US':
        'Purchase successful! Please keep an eye on your in-game mailbox.',
      'zh-CN': '儲值成功，請留意遊戲信件提示哦！',
      'zh-TW': '儲值成功，請留意遊戲信件提示哦！',
      'ko-KR': '충전했습니다. 게임 내 우편을 확인해주세요.',
      'ja-JP': '入金成功。ゲーム内の手紙にて確認してください！',
      'th-TH': 'เติมเงินสำเร็จ โปรดอย่าลืมเช็กอีเมลภายในเกมนะ!'
    },
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: true,
      activityName: 'dqvnpwagift'
    },
    // 添加到桌面背景和按钮
    pwaInstallPopupBg: require('@assets/image/officialWebStore/xddq/pwa-install-popup-bg.png'),
    pwaInstallPopupBtn: require('@assets/image/officialWebStore/xddq/pwa-install-popup-btn.png'),
    pwaInstall: require('@assets/image/officialWebStore/xddq/pwa-install.png'),
    pwaInstalledAward: require('@assets/image/officialWebStore/xddq/pwa-installed-award.png')
  },
  // 台港澳斗罗3D
  251: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'dlssr',
    //游戏名
    gameName: '斗羅大陸3D：魂師對決',
    //页面配置
    pageInfo: {
      pageTitle: '斗羅大陸3D：魂師對決官網儲值中心', // 页面title
      pageIco: require('@assets/image/officialWebStore/dlssr/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/dlssr/icon251.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/dlssr/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/dlssr/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/dlssr/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/dlssr/banner.jpg'), // 图片
        //     link: '' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: '斗羅大陸3D：魂師對決', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              // 文案
              text: '5%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/dlssr/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـ斗羅大陸3D：魂師對決  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom 斗羅大陸3D：魂師對決-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the 斗羅大陸3D：魂師對決 Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de 斗羅大陸3D：魂師對決. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de 斗羅大陸3D：魂師對決. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          '斗羅大陸3D：魂師對決 bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional 斗羅大陸3D：魂師對決  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  斗羅大陸3D：魂師對決  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal 斗羅大陸3D：魂師對決 Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『斗羅大陸3D：魂師對決』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『斗羅大陸3D：魂師對決』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          '斗羅大陸3D：魂師對決 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 斗羅大陸3D：魂師對決 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 斗羅大陸3D：魂師對決 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny 斗羅大陸3D：魂師對決. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações 斗羅大陸3D：魂師對決. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «斗羅大陸3D：魂師對決». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน 斗羅大陸3D：魂師對決 อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน 斗羅大陸3D：魂師對決 ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน 斗羅大陸3D：魂師對決 เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya 斗羅大陸3D：魂師對決 Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành 斗羅大陸3D：魂師對決 có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành 斗羅大陸3D：魂師對決 chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành 斗羅大陸3D：魂師對決 xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          '斗羅大陸3D：魂師對決 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 斗羅大陸3D：魂師對決 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 斗羅大陸3D：魂師對決 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          '斗羅大陸3D：魂師對決 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 斗羅大陸3D：魂師對決 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 斗羅大陸3D：魂師對決 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: '//guide.mycard520.com/mycard/152323/#event1', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/dlssr/welfare-ico-1.png'), //ico
        //   defaultLang: 'zh-TW', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'zh-TW': '人人龍有獎 ｜ MyCard'
        //   }
        // }
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/SoulLand3D', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        },
        {
          link: 'https://discord.gg/GYxqhs5E', // 跳转链接
          linkKey: 'discord', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-discord-ico.png'), //ico
          btnColor: '#6665d2', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Discord'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/dlssr/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/dlssr/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/dlssr/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/dlssr/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/dlssr/dlssr-currency-guide-1.png'),
        require('@assets/image/officialWebStore/dlssr/dlssr-currency-guide-2.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#7e92dd', //渐变按钮左
      gradientBtnRight: '#b9b0ee', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#7e92dd', //所有框体边框色高亮
      borderActiveShade: '#f3e1d5', // 所有框体边框高亮阴影色
      btnBg: '#7e92dd', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#f3e1d5', // 大按钮阴影色
      productName: '#e6779b', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'zh-TW', // 默认语言
      resource: {
        // 'zh-TW': {
        //   close: require('@assets/image/officialWebStore/dlssr/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dlssr/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dlssr/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 欧美斗罗3D
  294: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'slssr',
    //游戏名
    gameName: 'Soul Land:Clash of Spirimasters',
    //页面配置
    pageInfo: {
      pageTitle: 'official Top-Up', // 页面title
      pageIco: require('@assets/image/officialWebStore/slssr/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/slssr/icon294.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/dlssr/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/slssr/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/slssr/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/tmslg/banner.png'), // 图片
        //     link: '//www.baidu.com' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: false, // 是否开启优惠券入口
      isOpenVip: false, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Soul Land:Clash of Spirimasters', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              // 文案
              text: '5%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dlssr/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/dlssr/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـSoul Land:Clash of Spirimasters  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Soul Land:Clash of Spirimasters-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the Soul Land:Clash of Spirimasters Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Soul Land:Clash of Spirimasters. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Soul Land:Clash of Spirimasters. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'Soul Land:Clash of Spirimasters bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Soul Land:Clash of Spirimasters  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  Soul Land:Clash of Spirimasters  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Soul Land:Clash of Spirimasters Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『Soul Land:Clash of Spirimasters』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『Soul Land:Clash of Spirimasters』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          'Soul Land:Clash of Spirimasters 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 Soul Land:Clash of Spirimasters 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 Soul Land:Clash of Spirimasters 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Soul Land:Clash of Spirimasters. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Soul Land:Clash of Spirimasters. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Soul Land:Clash of Spirimasters». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน Soul Land:Clash of Spirimasters อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน Soul Land:Clash of Spirimasters ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน Soul Land:Clash of Spirimasters เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya Soul Land:Clash of Spirimasters Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành Soul Land:Clash of Spirimasters có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Soul Land:Clash of Spirimasters chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Soul Land:Clash of Spirimasters xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'Soul Land:Clash of Spirimasters 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Soul Land:Clash of Spirimasters 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 Soul Land:Clash of Spirimasters 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'Soul Land:Clash of Spirimasters 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Soul Land:Clash of Spirimasters 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 Soul Land:Clash of Spirimasters 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: '//www.baidu.com', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/welfare-ico-1.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Share for Gifts',
        //     'zh-CN': '分享活动'
        //   }
        // },
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/profile.php?id=100082901483654', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        },
        {
          link: 'https://discord.gg/bVJ7Va2NwQ', // 跳转链接
          linkKey: 'discord', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-discord-ico.png'), //ico
          btnColor: '#6665d2', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Discord'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/dlssr/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/dlssr/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/dlssr/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/dlssr/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/slssr/slssr-currency-guide-1.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#7e92dd', //渐变按钮左
      gradientBtnRight: '#b9b0ee', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#7e92dd', //所有框体边框色高亮
      borderActiveShade: '#f3e1d5', // 所有框体边框高亮阴影色
      btnBg: '#7e92dd', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#f3e1d5', // 大按钮阴影色
      productName: '#e6779b', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 台港澳空之要塞
  343: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'sfqh',
    //游戏名
    gameName: '空之要塞：啟航',
    //页面配置
    pageInfo: {
      pageTitle: '空之要塞：啟航開拓者神秘商店', // 页面title
      pageIco: require('@assets/image/officialWebStore/sfqh/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/sfqh/icon343.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/sfqh/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/sfqh/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/sfqh/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/tmslg/banner.png'), // 图片
        //     link: '//www.baidu.com' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: '空之要塞：啟航', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/sfqh/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـ空之要塞：啟航  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom 空之要塞：啟航-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the 空之要塞：啟航 Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de 空之要塞：啟航. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de 空之要塞：啟航. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          '空之要塞：啟航 bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional 空之要塞：啟航  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  空之要塞：啟航  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal 空之要塞：啟航 Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『空之要塞：啟航』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『空之要塞：啟航』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          '空之要塞：啟航 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 空之要塞：啟航 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 空之要塞：啟航 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny 空之要塞：啟航. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações 空之要塞：啟航. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «空之要塞：啟航». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน 空之要塞：啟航 อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน 空之要塞：啟航 ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน 空之要塞：啟航 เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya 空之要塞：啟航 Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành 空之要塞：啟航 có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành 空之要塞：啟航 chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành 空之要塞：啟航 xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          '空之要塞：啟航 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 空之要塞：啟航 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 空之要塞：啟航 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          '空之要塞：啟航 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 空之要塞：啟航 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 空之要塞：啟航 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: '//www.baidu.com', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/welfare-ico-1.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Share for Gifts',
        //     'zh-CN': '分享活动'
        //   }
        // },
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/SkyFortressTW/', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        },
        {
          link: 'https://discord.gg/uY4DHDRJyS', // 跳转链接
          linkKey: 'discord', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-discord-ico.png'), //ico
          btnColor: '#6665d2', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Discord'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/sfqh/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/sfqh/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/sfqh/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/sfqh/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/sfqh/sfqh-currency-guide-1.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#c19362', //渐变按钮左
      gradientBtnRight: '#e4bf97', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#c19362', //所有框体边框色高亮
      borderActiveShade: '#f3e1d5', // 所有框体边框高亮阴影色
      btnBg: '#c19362', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#f3e1d5', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 全球空之要塞
  314: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'kzys',
    //游戏名
    gameName: 'Sky Fortress: Odyssey',
    //页面配置
    pageInfo: {
      pageTitle: 'Sky Fortress: Odyssey Mysterious Shop', // 页面title
      pageIco: require('@assets/image/officialWebStore/kzys/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/kzys/icon314.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/sfqh/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/kzys/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/kzys/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/tmslg/banner.png'), // 图片
        //     link: '//www.baidu.com' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: false, // 是否开启优惠券入口
      isOpenVip: false, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Sky Fortress: Odyssey', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/sfqh/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـSky Fortress: Odyssey  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Sky Fortress: Odyssey-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the Sky Fortress: Odyssey Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Sky Fortress: Odyssey. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Sky Fortress: Odyssey. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'Sky Fortress: Odyssey bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Sky Fortress: Odyssey  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  Sky Fortress: Odyssey  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Sky Fortress: Odyssey Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『Sky Fortress: Odyssey』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『Sky Fortress: Odyssey』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          'Sky Fortress: Odyssey 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 Sky Fortress: Odyssey 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 Sky Fortress: Odyssey 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Sky Fortress: Odyssey. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Sky Fortress: Odyssey. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Sky Fortress: Odyssey». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน Sky Fortress: Odyssey อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน Sky Fortress: Odyssey ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน Sky Fortress: Odyssey เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya Sky Fortress: Odyssey Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành Sky Fortress: Odyssey có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Sky Fortress: Odyssey chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Sky Fortress: Odyssey xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'Sky Fortress: Odyssey 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Sky Fortress: Odyssey 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 Sky Fortress: Odyssey 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'Sky Fortress: Odyssey 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Sky Fortress: Odyssey 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 Sky Fortress: Odyssey 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: '//www.baidu.com', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/welfare-ico-1.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Share for Gifts',
        //     'zh-CN': '分享活动'
        //   }
        // },
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/SkyFortressEN', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        },
        {
          link: 'https://discord.gg/FCCERPYZrQ', // 跳转链接
          linkKey: 'discord', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-discord-ico.png'), //ico
          btnColor: '#6665d2', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Discord'
          }
        },
        {
          link: 'https://game.naver.com/lounge/skyfortress/board/detail/2828884', // 跳转链接
          linkKey: 'lounge', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-lounge-ico.png'), //ico
          btnColor: '#62d56f', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Lounge'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/sfqh/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/sfqh/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/sfqh/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/sfqh/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/kzys/kzys-currency-guide-en.png')
      ],
      'ko-KR': [
        require('@assets/image/officialWebStore/kzys/kzys-currency-guide-ko.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#c19362', //渐变按钮左
      gradientBtnRight: '#e4bf97', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#c19362', //所有框体边框色高亮
      borderActiveShade: '#f3e1d5', // 所有框体边框高亮阴影色
      btnBg: '#c19362', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#f3e1d5', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 日本空之要塞
  333: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'sfojp',
    //游戏名
    gameName: 'スカイフォートレス-オデッセイ',
    //页面配置
    pageInfo: {
      pageTitle: '『スカイフォートレス-オデッセイ』', // 页面title
      pageIco: require('@assets/image/officialWebStore/sfojp/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/sfojp/icon333.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/sfqh/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/sfojp/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/sfojp/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/tmslg/banner.png'), // 图片
        //     link: '//www.baidu.com' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: false, // 是否开启优惠券入口
      isOpenVip: false, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'スカイフォートレス-オデッセイ', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/sfqh/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/sfqh/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـスカイフォートレス-オデッセイ  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom スカイフォートレス-オデッセイ-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the スカイフォートレス-オデッセイ Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de スカイフォートレス-オデッセイ. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de スカイフォートレス-オデッセイ. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'スカイフォートレス-オデッセイ bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional スカイフォートレス-オデッセイ  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  スカイフォートレス-オデッセイ  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal スカイフォートレス-オデッセイ Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『スカイフォートレス-オデッセイ』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『スカイフォートレス-オデッセイ』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          'スカイフォートレス-オデッセイ 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 スカイフォートレス-オデッセイ 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 スカイフォートレス-オデッセイ 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny スカイフォートレス-オデッセイ. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações スカイフォートレス-オデッセイ. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «スカイフォートレス-オデッセイ». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน スカイフォートレス-オデッセイ อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน スカイフォートレス-オデッセイ ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน スカイフォートレス-オデッセイ เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya スカイフォートレス-オデッセイ Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành スカイフォートレス-オデッセイ có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành スカイフォートレス-オデッセイ chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành スカイフォートレス-オデッセイ xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'スカイフォートレス-オデッセイ 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 スカイフォートレス-オデッセイ 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 スカイフォートレス-オデッセイ 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'スカイフォートレス-オデッセイ 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 スカイフォートレス-オデッセイ 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 スカイフォートレス-オデッセイ 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: '//www.baidu.com', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/welfare-ico-1.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Share for Gifts',
        //     'zh-CN': '分享活动'
        //   }
        // },
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://twitter.com/skyfortress_jp', // 跳转链接
          linkKey: 'twitter', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-twitter-ico.png'), //ico
          btnColor: '#000000', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'X'
          }
        },
        {
          link: 'https://discord.gg/FCCERPYZrQ', // 跳转链接
          linkKey: 'discord', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-discord-ico.png'), //ico
          btnColor: '#6665d2', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Discord'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/sfqh/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/sfqh/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/sfqh/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/sfqh/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/sfojp/sfojp-currency-guide-1.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#c19362', //渐变按钮左
      gradientBtnRight: '#e4bf97', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#c19362', //所有框体边框色高亮
      borderActiveShade: '#f3e1d5', // 所有框体边框高亮阴影色
      btnBg: '#c19362', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#f3e1d5', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 斗罗3D东南亚版
  274: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'dl3dvn',
    //游戏名
    gameName: 'Douluo Dalu : สัประยุทธ์วิญญาจารย์',
    //页面配置
    pageInfo: {
      pageTitle: 'official Top-Up', // 页面title
      pageIco: require('@assets/image/officialWebStore/dl3dvn/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/dl3dvn/icon274.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/dl3dvn/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/dl3dvn/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/dl3dvn/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        'th-TH': [
          {
            img: require('@assets/image/officialWebStore/dl3dvn/banner.png'), // 图片
            link: `//auto-page.${mainHost}/douluo3dlineth/` // 跳转
          }
        ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Douluo Dalu : สัประยุทธ์วิญญาจารย์', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              text: '11%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              text: '13%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              text: '11%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              text: '11%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dl3dvn/vip-coupon.png'),
              text: '13%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/dl3dvn/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـDouluo Dalu : สัประยุทธ์วิญญาจารย์  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Douluo Dalu : สัประยุทธ์วิญญาจารย์-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the Douluo Dalu : สัประยุทธ์วิญญาจารย์ Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Douluo Dalu : สัประยุทธ์วิญญาจารย์. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Douluo Dalu : สัประยุทธ์วิญญาจารย์. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'Douluo Dalu : สัประยุทธ์วิญญาจารย์ bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Douluo Dalu : สัประยุทธ์วิญญาจารย์  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  Douluo Dalu : สัประยุทธ์วิญญาจารย์  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Douluo Dalu : สัประยุทธ์วิญญาจารย์ Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『Douluo Dalu : สัประยุทธ์วิญญาจารย์』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『Douluo Dalu : สัประยุทธ์วิญญาจารย์』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          'Douluo Dalu : สัประยุทธ์วิญญาจารย์ 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 Douluo Dalu : สัประยุทธ์วิญญาจารย์ 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 Douluo Dalu : สัประยุทธ์วิญญาจารย์ 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Douluo Dalu : สัประยุทธ์วิญญาจารย์. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Douluo Dalu : สัประยุทธ์วิญญาจารย์. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Douluo Dalu : สัประยุทธ์วิญญาจารย์». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน Douluo Dalu : สัประยุทธ์วิญญาจารย์ อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน Douluo Dalu : สัประยุทธ์วิญญาจารย์ ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน Douluo Dalu : สัประยุทธ์วิญญาจารย์ เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya Douluo Dalu : สัประยุทธ์วิญญาจารย์ Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành Douluo Dalu : สัประยุทธ์วิญญาจารย์ có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Douluo Dalu : สัประยุทธ์วิญญาจารย์ chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Douluo Dalu : สัประยุทธ์วิญญาจารย์ xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'Douluo Dalu : สัประยุทธ์วิญญาจารย์ 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Douluo Dalu : สัประยุทธ์วิญญาจารย์ 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 Douluo Dalu : สัประยุทธ์วิญญาจารย์ 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'Douluo Dalu : สัประยุทธ์วิญญาจารย์ 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Douluo Dalu : สัประยุทธ์วิญญาจารย์ 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 Douluo Dalu : สัประยุทธ์วิญญาจารย์ 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: '//www.baidu.com', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/welfare-ico-1.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Share for Gifts',
        //     'zh-CN': '分享活动'
        //   }
        // },
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/DouLuoDalu3D.TH/', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/dl3dvn/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/dl3dvn/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/dl3dvn/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/dl3dvn/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/dl3dvn/dl3dvn-currency-guide-1.png'),
        require('@assets/image/officialWebStore/dl3dvn/dl3dvn-currency-guide-2.png')
      ],
      'vi-VN': [
        require('@assets/image/officialWebStore/dl3dvn/dl3dvn-currency-guide-3.png'),
        require('@assets/image/officialWebStore/dl3dvn/dl3dvn-currency-guide-4.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#7e92dd', //渐变按钮左
      gradientBtnRight: '#b9b0ee', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#7e92dd', //所有框体边框色高亮
      borderActiveShade: '#f3e1d5', // 所有框体边框高亮阴影色
      btnBg: '#7e92dd', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#f3e1d5', // 大按钮阴影色
      productName: '#e6779b', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // Puzzles & Chaos全球版
  285: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'dtmslg',
    //游戏名
    gameName: 'Puzzles & Chaos',
    //页面配置
    pageInfo: {
      pageTitle: 'official Top-Up', // 页面title
      pageIco: require('@assets/image/officialWebStore/dtmslg/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/dtmslg/icon285.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/dtmslg/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/dtmslg/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/dtmslg/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        'en-US': [
          {
            img: require('@assets/image/officialWebStore/dtmslg/banner-1.png'), // 图片
            link: `https://auto-page.${mainHost}/k1lx01/` // 跳转
          }
        ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Puzzles & Chaos', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/dtmslg/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dtmslg/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dtmslg/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dtmslg/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dtmslg/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dtmslg/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dtmslg/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dtmslg/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dtmslg/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dtmslg/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/dtmslg/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـPuzzles & Chaos  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Puzzles & Chaos-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the Puzzles & Chaos Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Puzzles & Chaos. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Puzzles & Chaos. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'Puzzles & Chaos bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Puzzles & Chaos  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  Puzzles & Chaos  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Puzzles & Chaos Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『Puzzles & Chaos』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『Puzzles & Chaos』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          'Puzzles & Chaos 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 Puzzles & Chaos 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 Puzzles & Chaos 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Puzzles & Chaos. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Puzzles & Chaos. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Puzzles & Chaos». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน Puzzles & Chaos อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน Puzzles & Chaos ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน Puzzles & Chaos เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya Puzzles & Chaos Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành Puzzles & Chaos có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Puzzles & Chaos chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Puzzles & Chaos xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'Puzzles & Chaos 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Puzzles & Chaos 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 Puzzles & Chaos 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'Puzzles & Chaos 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Puzzles & Chaos 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 Puzzles & Chaos 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        {
          link: `https://auto-page.${mainHost}/k1lx01/`, // 跳转链接
          linkKey: '', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/dtmslg/welfare-ico-2.png'), //ico
          defaultLang: 'en-US', // 文案默认语言
          text: {
            // 文案配置
            'en-US': 'Claim Your Reward！'
          }
        }
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/PuzzlesAndChaos', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        },
        {
          link: 'https://discord.com/invite/dDHjg65vGW', // 跳转链接
          linkKey: 'discord', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-discord-ico.png'), //ico
          btnColor: '#6665d2', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Discord'
          }
        }
        // {
        //   link: '', // 跳转链接
        //   linkKey: 'homepage', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/community-website-ico.png'), //ico
        //   btnColor: '#ffa200', // 按钮颜色
        //   text: {
        //     // 文案配置
        //     'en-US': 'Game Website'
        //   }
        // }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/dtmslg/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/dtmslg/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/dtmslg/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/dtmslg/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/dtmslg/dtmslg-currency-guide-1.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#306da6', //渐变按钮左
      gradientBtnRight: '#94b5e2', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#306da6', //所有框体边框色高亮
      borderActiveShade: '#cbdeec', // 所有框体边框高亮阴影色
      btnBg: '#306da6', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#cbdeec', // 大按钮阴影色
      productName: '#6a86b1', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'zh-TW': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: true, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: true,
      activityName: 'k1pwagift'
    },
    // 添加到桌面背景和按钮
    pwaInstallPopupBg: require('@assets/image/officialWebStore/dtmslg/pwa-install-popup-bg.png'),
    pwaInstallPopupBtn: require('@assets/image/officialWebStore/dtmslg/pwa-install-popup-btn.png'),
    pwaInstall: require('@assets/image/officialWebStore/dtmslg/pwa-install.png'),
    pwaInstalledAward: require('@assets/image/officialWebStore/dtmslg/pwa-installed-award.png')
  },
  // 全球王室传奇
  310: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'wscq',
    //游戏名
    gameName: 'Yes Your Highness',
    //页面配置
    pageInfo: {
      pageTitle: 'Yes Your Highness', // 页面title
      pageIco: require('@assets/image/officialWebStore/wscq/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/wscq/icon310.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/wscq/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/wscq/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/wscq/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/tmslg/banner.png'), // 图片
        //     link: '//www.baidu.com' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Yes Your Highness', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/wscq/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/wscq/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـYes Your Highness  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Yes Your Highness-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the Yes Your Highness Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Yes Your Highness. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Yes Your Highness. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'Yes Your Highness bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Yes Your Highness  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  Yes Your Highness  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Yes Your Highness Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『Yes Your Highness』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『Yes Your Highness』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          'Yes Your Highness 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 Yes Your Highness 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 Yes Your Highness 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Yes Your Highness. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Yes Your Highness. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Yes Your Highness». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน Yes Your Highness อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน Yes Your Highness ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน Yes Your Highness เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya Yes Your Highness Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành Yes Your Highness có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Yes Your Highness chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Yes Your Highness xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'Yes Your Highness 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Yes Your Highness 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 Yes Your Highness 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'Yes Your Highness 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Yes Your Highness 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 Yes Your Highness 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: '//www.baidu.com', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/welfare-ico-1.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Share for Gifts',
        //     'zh-CN': '分享活动'
        //   }
        // },
      ],
      // 社群列表
      communityList: [
        // {
        //   link: 'https://www.facebook.com/PuzzlesAndChaos', // 跳转链接
        //   linkKey: 'facebook', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
        //   btnColor: '#008aff', // 按钮颜色
        //   text: {
        //     // 文案配置
        //     'en-US': 'Facebook'
        //   }
        // },
        {
          link: 'https://discord.gg/yb2F9ZmWaz', // 跳转链接
          linkKey: 'discord', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-discord-ico.png'), //ico
          btnColor: '#6665d2', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Discord'
          }
        }
        // {
        //   link: '', // 跳转链接
        //   linkKey: 'homepage', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/community-website-ico.png'), //ico
        //   btnColor: '#ffa200', // 按钮颜色
        //   text: {
        //     // 文案配置
        //     'en-US': 'Game Website'
        //   }
        // }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/wscq/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/wscq/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/wscq/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/wscq/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/wscq/wscq-currency-guide-1.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#b17f6a', //渐变按钮左
      gradientBtnRight: '#e2ab94', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#652a0b', //所有框体边框色高亮
      borderActiveShade: '#ecd9cb', // 所有框体边框高亮阴影色
      btnBg: '#b17f6a', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#ecd9cb', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 台港澳彩虹联萌
  336: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'tale',
    //游戏名
    gameName: '彩虹聯萌',
    //页面配置
    pageInfo: {
      pageTitle: '彩虹聯萌', // 页面title
      pageIco: require('@assets/image/officialWebStore/tale/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/tale/icon336.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/tale/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/tale/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/tale/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/tmslg/banner.png'), // 图片
        //     link: '//www.baidu.com' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: false, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: '彩虹聯萌', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/tale/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/tale/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـ彩虹聯萌  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom 彩虹聯萌-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the 彩虹聯萌 Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de 彩虹聯萌. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de 彩虹聯萌. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          '彩虹聯萌 bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional 彩虹聯萌  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  彩虹聯萌  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal 彩虹聯萌 Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『彩虹聯萌』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『彩虹聯萌』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          '彩虹聯萌 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 彩虹聯萌 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 彩虹聯萌 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny 彩虹聯萌. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações 彩虹聯萌. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «彩虹聯萌». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน 彩虹聯萌 อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน 彩虹聯萌 ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน 彩虹聯萌 เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya 彩虹聯萌 Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành 彩虹聯萌 có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành 彩虹聯萌 chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành 彩虹聯萌 xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          '彩虹聯萌 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 彩虹聯萌 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 彩虹聯萌 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          '彩虹聯萌 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 彩虹聯萌 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 彩虹聯萌 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: '//www.baidu.com', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/welfare-ico-1.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Share for Gifts',
        //     'zh-CN': '分享活动'
        //   }
        // },
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/profile.php?id=100095404418327', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/tale/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/tale/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/tale/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/tale/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        // require('@assets/image/officialWebStore/tale/tale-currency-guide-1.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#7e92dd', //渐变按钮左
      gradientBtnRight: '#b9b0ee', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#7e92dd', //所有框体边框色高亮
      borderActiveShade: '#f3e1d5', // 所有框体边框高亮阴影色
      btnBg: '#7e92dd', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#f3e1d5', // 大按钮阴影色
      productName: '#e6779b', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案 每个地区不同
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 全球勇者超派
  361: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'heroglo',
    //游戏名
    gameName: 'Oops! Dragon',
    //页面配置
    pageInfo: {
      pageTitle: 'Oops! Dragon', // 页面title
      pageIco: require('@assets/image/officialWebStore/heroglo/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/heroglo/icon361.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/heroglo/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/heroglo/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/heroglo/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/tmslg/banner.png'), // 图片
        //     link: '//www.baidu.com' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: false, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Oops! Dragon', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/heroglo/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/heroglo/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـOops! Dragon  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Oops! Dragon-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the Oops! Dragon Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Oops! Dragon. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Oops! Dragon. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'Oops! Dragon bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Oops! Dragon  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  Oops! Dragon  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Oops! Dragon Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『Oops! Dragon』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『Oops! Dragon』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          'Oops! Dragon 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 Oops! Dragon 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 Oops! Dragon 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Oops! Dragon. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Oops! Dragon. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Oops! Dragon». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน Oops! Dragon อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน Oops! Dragon ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน Oops! Dragon เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya Oops! Dragon Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành Oops! Dragon có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Oops! Dragon chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Oops! Dragon xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'Oops! Dragon 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Oops! Dragon 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 Oops! Dragon 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'Oops! Dragon 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Oops! Dragon 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 Oops! Dragon 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: '//www.baidu.com', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/welfare-ico-1.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Share for Gifts',
        //     'zh-CN': '分享活动'
        //   }
        // },
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/profile.php?id=61554833590761', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/heroglo/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/heroglo/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/heroglo/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/heroglo/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        // require('@assets/image/officialWebStore/heroglo/heroglo-currency-guide-1.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#1dd5e6', //渐变按钮左
      gradientBtnRight: '#46aef7', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#37abe6', //所有框体边框色高亮
      borderActiveShade: '#ecd9cb', // 所有框体边框高亮阴影色
      btnBg: '#00cfe0', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#ecd9cb', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案 每个地区不同
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 欧美小鸡出击
  365: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'bawk',
    //游戏名
    gameName: 'Bawk Bawk Rush',
    //页面配置
    pageInfo: {
      pageTitle: 'official Top-Up', // 页面title
      pageIco: require('@assets/image/officialWebStore/bawk/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/bawk/icon365.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/bawk/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/bawk/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/bawk/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/tmslg/banner.png'), // 图片
        //     link: '//www.baidu.com' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: false, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Bawk Bawk Rush', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bawk/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/bawk/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـBawk Bawk Rush  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Bawk Bawk Rush-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the Bawk Bawk Rush Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Bawk Bawk Rush. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Bawk Bawk Rush. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'Bawk Bawk Rush bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Bawk Bawk Rush  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  Bawk Bawk Rush  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Bawk Bawk Rush Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『Bawk Bawk Rush』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『Bawk Bawk Rush』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          'Bawk Bawk Rush 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 Bawk Bawk Rush 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 Bawk Bawk Rush 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Bawk Bawk Rush. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Bawk Bawk Rush. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Bawk Bawk Rush». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน Bawk Bawk Rush อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน Bawk Bawk Rush ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน Bawk Bawk Rush เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya Bawk Bawk Rush Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành Bawk Bawk Rush có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Bawk Bawk Rush chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Bawk Bawk Rush xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'Bawk Bawk Rush 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Bawk Bawk Rush 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 Bawk Bawk Rush 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'Bawk Bawk Rush 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Bawk Bawk Rush 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 Bawk Bawk Rush 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: '//www.baidu.com', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/welfare-ico-1.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Share for Gifts',
        //     'zh-CN': '分享活动'
        //   }
        // },
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/profile.php?id=61555485162313', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/bawk/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/bawk/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/bawk/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/bawk/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        // require('@assets/image/officialWebStore/bawk/bawk-currency-guide-1.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#496cf1', //渐变按钮左
      gradientBtnRight: '#6686fe', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#365be5', //所有框体边框色高亮
      borderActiveShade: '#d2ddf8', // 所有框体边框高亮阴影色
      btnBg: '#365be5', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#d2ddf8', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案 每个地区不同
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 全球凡人修仙
  303: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'frxxkr',
    //游戏名
    gameName: '검의꽃M',
    //页面配置
    pageInfo: {
      pageTitle: 'official Top-Up', // 页面title
      pageIco: require('@assets/image/officialWebStore/frxxkr/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/frxxkr/icon303.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/frxxkr/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/frxxkr/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/frxxkr/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/frxxkr/banner-1.jpg'), // 图片
        //     link: 'https://auto-page.omnikade.com/frkf01/' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Legacy of Divinity', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              // 文案
              text: '5%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '3%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '12%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/frxxkr/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـLegacy of Divinity  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Legacy of Divinity-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the Legacy of Divinity Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Legacy of Divinity. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Legacy of Divinity. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'Legacy of Divinity bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Legacy of Divinity  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  Legacy of Divinity  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Legacy of Divinity Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『Legacy of Divinity』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『Legacy of Divinity』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          '검의꽃M 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 검의꽃M 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 검의꽃M 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Legacy of Divinity. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Legacy of Divinity. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Legacy of Divinity». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน ตำนานแห่งเซียน อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน ตำนานแห่งเซียน ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน ตำนานแห่งเซียน เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya Legacy of Divinity Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành Phàm Nhân Tu Tiên: Duyên Khởi có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Phàm Nhân Tu Tiên: Duyên Khởi chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Phàm Nhân Tu Tiên: Duyên Khởi xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'Legacy of Divinity 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Legacy of Divinity 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 Legacy of Divinity 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'Legacy of Divinity 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Legacy of Divinity 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 Legacy of Divinity 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: 'https://auto-page.omnikade.com/frkf01/', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/frxxkr/welfare-ico-1.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'New Journey Gift'
        //   }
        // },
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://discord.gg/9XsXFKfF2K?cid=&gameId=303&scid=gameicon', // 跳转链接
          linkKey: 'discord', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-discord-ico.png'), //ico
          btnColor: '#6665d2', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Discord'
          }
        },
        {
          link: 'https://game.naver.com/lounge/BladeBlossom/home?cid=&gameId=303&scid=gameiconKR', // 跳转链接
          linkKey: 'lounge', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-lounge-ico.png'), //ico
          btnColor: '#62d56f', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Lounge'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/frxxkr/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/frxxkr/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/frxxkr/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/frxxkr/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/frxxkr/frxxkr-currency-guide-1.jpg')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#3c85dc', //渐变按钮左
      gradientBtnRight: '#1e6ac6', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#3c85dc', //所有框体边框色高亮
      borderActiveShade: '#e8eccb', // 所有框体边框高亮阴影色
      btnBg: '#3c85dc', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#e8eccb', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案 每个地区不同
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: true,
      activityName: 'frxxpwagift'
    },
    // 添加到桌面背景和按钮
    pwaInstallPopupBg: require('@assets/image/officialWebStore/frxxkr/pwa-install-popup-bg.png'),
    pwaInstallPopupBtn: require('@assets/image/officialWebStore/frxxkr/pwa-install-popup-btn.png'),
    pwaInstall: require('@assets/image/officialWebStore/frxxkr/pwa-install.png'),
    pwaInstalledAward: require('@assets/image/officialWebStore/frxxkr/pwa-installed-award.png')
  },
  // 越南凡人修仙
  301: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'frxxvn',
    //游戏名
    gameName: 'Phàm Nhân Tu Tiên: Duyên Khởi',
    //页面配置
    pageInfo: {
      pageTitle: 'official Top-Up', // 页面title
      pageIco: require('@assets/image/officialWebStore/frxxkr/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/frxxvn/icon301.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/frxxvn/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/frxxkr/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/frxxvn/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/frxxvn/banner-1.jpg'), // 图片
        //     link: 'https://auto-page.olgamevn.com/frxxvn01/' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: false, // 是否开启优惠券入口
      isOpenVip: false, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Phàm Nhân Tu Tiên: Duyên Khởi', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/frxxkr/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/frxxvn/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـLegacy of Divinity  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Legacy of Divinity-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the Legacy of Divinity Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Legacy of Divinity. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Legacy of Divinity. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'Legacy of Divinity bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Legacy of Divinity  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  Legacy of Divinity  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Legacy of Divinity Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『Legacy of Divinity』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『Legacy of Divinity』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          '검의꽃M 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 검의꽃M 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 검의꽃M 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Legacy of Divinity. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Legacy of Divinity. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Legacy of Divinity». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน ตำนานแห่งเซียน อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน ตำนานแห่งเซียน ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน ตำนานแห่งเซียน เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya Legacy of Divinity Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành Phàm Nhân Tu Tiên: Duyên Khởi có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Phàm Nhân Tu Tiên: Duyên Khởi chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Phàm Nhân Tu Tiên: Duyên Khởi xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'Legacy of Divinity 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Legacy of Divinity 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 Legacy of Divinity 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'Legacy of Divinity 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Legacy of Divinity 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 Legacy of Divinity 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: 'https://auto-page.olgamevn.com/frxxvn01/', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/frxxkr/welfare-ico-1.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Quà Bắt Đầu Tu Tiên'
        //   }
        // },
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/pnttduyenkhoivn/?cid=&gameId=301&scid=gameicon', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/frxxkr/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/frxxkr/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/frxxkr/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/frxxvn/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/frxxvn/frxxvn-currency-guide-1.jpg')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#229ca9', //渐变按钮左
      gradientBtnRight: '#08727d', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#229ca9', //所有框体边框色高亮
      borderActiveShade: '#e8eccb', // 所有框体边框高亮阴影色
      btnBg: '#229ca9', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#e8eccb', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案 每个地区不同
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: true,
      activityName: 'frxxvnpwagift'
    },
    // 添加到桌面背景和按钮
    pwaInstallPopupBg: require('@assets/image/officialWebStore/frxxkr/pwa-install-popup-bg.png'),
    pwaInstallPopupBtn: require('@assets/image/officialWebStore/frxxkr/pwa-install-popup-btn.png'),
    pwaInstall: require('@assets/image/officialWebStore/frxxkr/pwa-install.png'),
    pwaInstalledAward: require('@assets/image/officialWebStore/frxxkr/pwa-installed-award.png')
  },
  // ROV东南亚版
  371: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'rov',
    //游戏名
    gameName: 'Ragnarok Vertical',
    //页面配置
    pageInfo: {
      pageTitle: 'official Top-Up', // 页面title
      pageIco: require('@assets/image/officialWebStore/rov/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/rov/icon371.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/rov/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/rov/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/rov/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        'en-US': [
          {
            img: require('@assets/image/officialWebStore/rov/banner.png'), // 图片
            link: '//auto-page.gnjoy.hk/rorzd02/' // 跳转
          }
        ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: false, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Ragnarok Vertical', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/rov/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/rov/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـRagnarok Vertical  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Ragnarok Vertical-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the Ragnarok Vertical Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Ragnarok Vertical. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Ragnarok Vertical. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'Ragnarok Vertical bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Ragnarok Vertical  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  Ragnarok Vertical  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Ragnarok Vertical Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『Ragnarok Vertical』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『Ragnarok Vertical』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          'Ragnarok Vertical 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 Ragnarok Vertical 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 Ragnarok Vertical 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Ragnarok Vertical. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Ragnarok Vertical. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Ragnarok Vertical». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน Ragnarok Vertical อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน Ragnarok Vertical ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน Ragnarok Vertical เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya Ragnarok Vertical Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành Ragnarok Vertical có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Ragnarok Vertical chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Ragnarok Vertical xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'Ragnarok Vertical 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Ragnarok Vertical 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 Ragnarok Vertical 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'Ragnarok Vertical 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Ragnarok Vertical 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 Ragnarok Vertical 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        {
          link: '//auto-page.gnjoy.hk/rovghjfs/', // 跳转链接
          linkKey: '', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/rov/welfare-ico-2.png'), //ico
          defaultLang: 'en-US', // 文案默认语言
          text: {
            // 文案配置
            'en-US': 'Claim your Reward!'
          }
        }
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/profile.php?id=61556516476345', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        },
        {
          link: 'https://discord.gg/PyScW8cPu6', // 跳转链接
          linkKey: 'discord', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-discord-ico.png'), //ico
          btnColor: '#6665d2', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Discord'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/rov/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/rov/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/rov/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/rov/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        // require('@assets/image/officialWebStore/rov/rov-currency-guide-1.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#805e40', //渐变按钮左
      gradientBtnRight: '#a67952', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#805e40', //所有框体边框色高亮
      borderActiveShade: '#f3e1d5', // 所有框体边框高亮阴影色
      btnBg: '#a67952', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#f3e1d5', // 大按钮阴影色
      productName: '#e2628c', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 全球动物王朝
  372: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'dnwc',
    //游戏名
    gameName: 'Fur the Empire',
    //页面配置
    pageInfo: {
      pageTitle: 'Fur the Empire', // 页面title
      pageIco: require('@assets/image/officialWebStore/dnwc/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/dnwc/icon372.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/dnwc/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/dnwc/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/dnwc/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/tmslg/banner.png'), // 图片
        //     link: '//www.baidu.com' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Fur the Empire', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/dnwc/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/dnwc/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـFur the Empire  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Fur the Empire-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the Fur the Empire Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Fur the Empire. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Fur the Empire. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'Fur the Empire bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Fur the Empire  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  Fur the Empire  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Fur the Empire Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『Fur the Empire』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『Fur the Empire』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          'Fur the Empire 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 Fur the Empire 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 Fur the Empire 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Fur the Empire. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Fur the Empire. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Fur the Empire». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน Fur the Empire อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน Fur the Empire ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน Fur the Empire เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya Fur the Empire Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành Fur the Empire có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Fur the Empire chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Fur the Empire xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'Fur the Empire 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Fur the Empire 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 Fur the Empire 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'Fur the Empire 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Fur the Empire 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 Fur the Empire 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: `//auto-page.${mainHost}/dqseaeu_sfcz/`, // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/xddqsea/welfare-ico-1.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Total Top-Up Gift',
        //     'zh-CN': '累计充值领好礼',
        //     'zh-TW': '累計儲值領好禮',
        //     'ja-JP': '合計購入額で報酬GET',
        //     'ko-KR': '누적 충전 선물',
        //     'th-TH': 'เติมเงินสะสม รับรางวัล'
        //   }
        // }
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://discord.gg/6sdaMZZMNU', // 跳转链接
          linkKey: 'discord', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-discord-ico.png'), //ico
          btnColor: '#6665d2', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Discord'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/dnwc/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/dnwc/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/dnwc/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/dnwc/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/dnwc/dnwc-currency-guide-en.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#b28e49', //渐变按钮左
      gradientBtnRight: '#bda33b', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#b28e49', //所有框体边框色高亮
      borderActiveShade: '#dacdb5', // 所有框体边框高亮阴影色
      btnBg: '#b28e49', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#dacdb5', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 血月台港澳版
  356: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'bm',
    //游戏名
    gameName: '血月: 惡魔傳說',
    //页面配置
    pageInfo: {
      pageTitle: 'official Top-Up', // 页面title
      pageIco: require('@assets/image/officialWebStore/bm/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/bm/icon356.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/bm/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/bm/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/bm/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/tmslg/banner.png'), // 图片
        //     link: '//www.baidu.com' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: false, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: '血月: 惡魔傳說', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bm/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/bm/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـ血月: 惡魔傳說  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom 血月: 惡魔傳說-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the 血月: 惡魔傳說 Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de 血月: 惡魔傳說. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de 血月: 惡魔傳說. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          '血月: 惡魔傳說 bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional 血月: 惡魔傳說  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  血月: 惡魔傳說  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal 血月: 惡魔傳說 Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『血月: 惡魔傳說』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『血月: 惡魔傳說』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          '血月: 惡魔傳說 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 血月: 惡魔傳說 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 血月: 惡魔傳說 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny 血月: 惡魔傳說. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações 血月: 惡魔傳說. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «血月: 惡魔傳說». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน 血月: 惡魔傳說 อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน 血月: 惡魔傳說 ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน 血月: 惡魔傳說 เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya 血月: 惡魔傳說 Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành 血月: 惡魔傳說 có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành 血月: 惡魔傳說 chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành 血月: 惡魔傳說 xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          '血月: 惡魔傳說 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 血月: 惡魔傳說 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 血月: 惡魔傳說 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          '血月: 惡魔傳說 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 血月: 惡魔傳說 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 血月: 惡魔傳說 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: `//auto-page.${mainHost}/dqseaeu_sfcz/`, // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/xddqsea/welfare-ico-1.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Total Top-Up Gift',
        //     'zh-CN': '累计充值领好礼',
        //     'zh-TW': '累計儲值領好禮',
        //     'ja-JP': '合計購入額で報酬GET',
        //     'ko-KR': '누적 충전 선물',
        //     'th-TH': 'เติมเงินสะสม รับรางวัล'
        //   }
        // }
      ],
      // 社群列表
      communityList: [
        // {
        //   link: '', // 跳转链接
        //   linkKey: 'discord', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/community-discord-ico.png'), //ico
        //   btnColor: '#6665d2', // 按钮颜色
        //   text: {
        //     // 文案配置
        //     'en-US': 'Discord'
        //   }
        // }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/bm/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/bm/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/bm/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/bm/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/bm/bm-currency-guide.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#3a4c72', //渐变按钮左
      gradientBtnRight: '#a54a9c', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#b13130', //所有框体边框色高亮
      borderActiveShade: '#ffe5e5', // 所有框体边框高亮阴影色
      btnBg: '#b13130', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#ffe5e5', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 霸业2.0台港澳版
  379: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'bwzytw',
    //游戏名
    gameName: '極速三國：一秒開戰',
    //页面配置
    pageInfo: {
      pageTitle: '極速三國：一秒開戰', // 页面title
      pageIco: require('@assets/image/officialWebStore/bwzytw/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/bwzytw/icon379.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/bwzytw/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/bwzytw/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/bwzytw/banner.jpg'), // 无轮播时默认图片
      list:
        new Date().toISOString() < '2025-07-24T23:59:59Z'
          ? {
            // 轮播图列表
            'en-US': [
              {
                img: require('@assets/image/officialWebStore/bwzytw/banner.png'), // 图片
                link: '//auto-page.playplanetgame.com/bytwxf01/' // 跳转
              }
            ]
          }
          : {}
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: '極速三國：一秒開戰', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              // 文案
              text: '6%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/bwzytw/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـ極速三國：一秒開戰  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom 極速三國：一秒開戰-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the 極速三國：一秒開戰 Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de 極速三國：一秒開戰. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de 極速三國：一秒開戰. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          '極速三國：一秒開戰 bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional 極速三國：一秒開戰  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  極速三國：一秒開戰  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal 極速三國：一秒開戰 Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『極速三國：一秒開戰』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『極速三國：一秒開戰』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          '極速三國：一秒開戰 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 極速三國：一秒開戰 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 極速三國：一秒開戰 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny 極速三國：一秒開戰. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações 極速三國：一秒開戰. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «極速三國：一秒開戰». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน 極速三國：一秒開戰 อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน 極速三國：一秒開戰 ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน 極速三國：一秒開戰 เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya 極速三國：一秒開戰 Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành 極速三國：一秒開戰 có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành 極速三國：一秒開戰 chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành 極速三國：一秒開戰 xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          '極速三國：一秒開戰 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 極速三國：一秒開戰 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 極速三國：一秒開戰 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          '極速三國：一秒開戰 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 極速三國：一秒開戰 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 極速三國：一秒開戰 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList:
        new Date().toISOString() < '2025-07-24T23:59:59Z'
          ? [
            {
              link: '//auto-page.playplanetgame.com/bytwxf01/', // 跳转链接
              linkKey: '', // 链接key，用于打点上报
              ico: require('@assets/image/officialWebStore/bwzytw/bytwxf01-ico.png'), //ico
              defaultLang: 'en-US', // 文案默认语言
              text: {
                // 文案配置
                'en-US': '週年新服豪禮燃戰！'
              }
            }
          ]
          : [],
      // 社群列表
      communityList: [
        // {
        //   link: '', // 跳转链接
        //   linkKey: 'discord', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/community-discord-ico.png'), //ico
        //   btnColor: '#6665d2', // 按钮颜色
        //   text: {
        //     // 文案配置
        //     'en-US': 'Discord'
        //   }
        // }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/bwzytw/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/bwzytw/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/bwzytw/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/bwzytw/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/bwzytw/bwzytw-currency-guide.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#886122', //渐变按钮左
      gradientBtnRight: '#c69546', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#886122', //所有框体边框色高亮
      borderActiveShade: '#ecdecb', // 所有框体边框高亮阴影色
      btnBg: '#886122', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#ecdecb', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    isShowPreRightsPopup: true, // 是否展示上线前弹窗
    offLineTime: '2025-02-06T23:59:59Z', // 公告下线时间后不再弹窗时间，需加上时区信息
    offLineDate: {
      'zh-TW': '2025-02-06 23:59:59 (UTC+8)',
      'zh-CN': '2025-02-06 23:59:59 (UTC+8)',
      'vi-VN': '23:59:59 (UTC+8) ngày 02/06/2025',
      'tr-TR': '06/02/2025 23.59.59 (UTC+8)',
      'th-TH': '2025-02-06 เวลา 23:59:59 น.(UTC+8)',
      'ru-RU': '2025/02/06 23:59:59 (UTC+8)',
      'pt-PT': '06/02/2025 23:59:59 (UTC+8)',
      'pl-PL': '2025/02/06 23:59:59 (UTC+8)',
      'ko-KR': '2025-02-06 23:59:59(UTC+8)',
      'ja-JP': '2025 年 2 月 6 日 23:59:59(UTC+8)',
      'it-IT': '06/02/2025 23:59:59 (UTC+8)',
      'id-ID': '06/02/2025 23:59:59 (UTC+8)',
      'fr-FR': '06/02/2025 23:59:59 (UTC+8)',
      'es-ES': '06/02/2025 23:59:59 (UTC+8)',
      'en-US': '2025/02/06 23:59:59 (UTC+8)',
      'de-DE': '06.02.2025, 23:59:59 Uhr (UTC+8)',
      'ar-SA': '06-02-2025 23:59:59 (UTC+8)'
    }, // 配置公告下线时间
    preRightsPopupLink: '', // 上线前弹窗链接
    isOnlineRightsCenter: true, // 是否上线权益中心
    rightsCenterLink: `//auto-page.${mainHost}/bytwvip01/`, // 权益中心链接
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 霸业2.0韩语版
  381: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'bwzykr',
    //游戏名
    gameName: '질풍삼국',
    //页面配置
    pageInfo: {
      pageTitle: '질풍삼국', // 页面title
      pageIco: require('@assets/image/officialWebStore/bwzykr/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/bwzykr/icon381.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/bwzykr/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/bwzykr/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/bwzykr/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        'en-US':
          new Date().getTime() < new Date('2024/11/17 23:59:59').getTime()
            ? [
              {
                img: require('@assets/image/officialWebStore/bwzykr/banner.png'),
                link: '//auto-page.omnikade.com/bykrkf01/'
              }
            ]
            : []
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: '질풍삼국', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              // 文案
              text: '6%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzykr/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/bwzykr/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـ질풍삼국  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom 질풍삼국-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the 질풍삼국 Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de 질풍삼국. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de 질풍삼국. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          '질풍삼국 bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional 질풍삼국  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  질풍삼국  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal 질풍삼국 Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『질풍삼국』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『질풍삼국』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          '질풍삼국 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 질풍삼국 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 질풍삼국 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny 질풍삼국. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações 질풍삼국. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «질풍삼국». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน 질풍삼국 อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน 질풍삼국 ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน 질풍삼국 เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya 질풍삼국 Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành 질풍삼국 có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành 질풍삼국 chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành 질풍삼국 xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          '질풍삼국 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 질풍삼국 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 질풍삼국 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          '질풍삼국 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 질풍삼국 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 질풍삼국 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: `//auto-page.${mainHost}/dqseaeu_sfcz/`, // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/xddqsea/welfare-ico-1.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Total Top-Up Gift',
        //     'zh-CN': '累计充值领好礼',
        //     'zh-TW': '累計儲值領好禮',
        //     'ja-JP': '合計購入額で報酬GET',
        //     'ko-KR': '누적 충전 선물',
        //     'th-TH': 'เติมเงินสะสม รับรางวัล'
        //   }
        // }
      ],
      // 社群列表
      communityList: [
        // {
        //   link: '', // 跳转链接
        //   linkKey: 'discord', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/community-discord-ico.png'), //ico
        //   btnColor: '#6665d2', // 按钮颜色
        //   text: {
        //     // 文案配置
        //     'en-US': 'Discord'
        //   }
        // }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/bwzykr/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/bwzykr/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/bwzykr/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/bwzykr/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/bwzykr/bwzykr-currency-guide.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#8c6f4a', //渐变按钮左
      gradientBtnRight: '#dbb96e', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#90734c', //所有框体边框色高亮
      borderActiveShade: '#ecdfcb', // 所有框体边框高亮阴影色
      btnBg: '#90734c', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#ecdfcb', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    isShowPreRightsPopup: true, // 是否展示上线前弹窗
    offLineTime: '2025-02-24T23:59:59+09:00', // 公告下线时间后不再弹窗时间，需加上时区信息
    offLineDate: {
      'zh-TW': '2025-02-24 23:59:59 (UTC+9)',
      'zh-CN': '2025-02-24 23:59:59 (UTC+9)',
      'vi-VN': '23:59:59 (UTC+9) ngày 24/02/2025',
      'tr-TR': '24/02/2025 23.59.59 (UTC+9)',
      'th-TH': '2025-02-24 เวลา 23:59:59 น.(UTC+9)',
      'ru-RU': '2025/02/24 23:59:59 (UTC+9)',
      'pt-PT': '24/02/2025 23:59:59 (UTC+9)',
      'pl-PL': '2025/02/24 23:59:59 (UTC+9)',
      'ko-KR': '2025-02-24 23:59:59(UTC+9)',
      'ja-JP': '2025 年 02 月 24 日 23:59:59(UTC+9)',
      'it-IT': '24/02/2025 23:59:59 (UTC+9)',
      'id-ID': '24/02/2025 23:59:59 (UTC+9)',
      'fr-FR': '24/02/2025 23:59:59 (UTC+9)',
      'es-ES': '24/02/2025 23:59:59 (UTC+9)',
      'en-US': '2025/02/24 23:59:59 (UTC+9)',
      'de-DE': '24.02.2025, 23:59:59 Uhr (UTC+9)',
      'ar-SA': '24-02-2025 23:59:59 (UTC+9)'
    }, // 配置公告下线时间
    preRightsPopupLink: '', // 上线前弹窗链接
    isOnlineRightsCenter: true, // 是否上线权益中心
    rightsCenterLink: `//auto-page.${mainHost}/byhgvip01/`, // 权益中心链接
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 霸业2.0日语版
  382: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'bwzyjp',
    //游戏名
    gameName: '爆速三国-フルスロットル',
    //页面配置
    pageInfo: {
      pageTitle: '爆速三国-フルスロットル', // 页面title
      pageIco: require('@assets/image/officialWebStore/bwzyjp/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/bwzyjp/icon382.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/bwzytw/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/bwzyjp/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/bwzytw/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/bwzytw/banner.png'), // 图片
        //     link: '//auto-page.playplanetgame.com/byzq01/' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: '爆速三国-フルスロットル', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              // 文案
              text: '7%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/bwzytw/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/bwzytw/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـ爆速三国-フルスロットル  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom 爆速三国-フルスロットル-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the 爆速三国-フルスロットル Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de 爆速三国-フルスロットル. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de 爆速三国-フルスロットル. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          '爆速三国-フルスロットル bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional 爆速三国-フルスロットル  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  爆速三国-フルスロットル  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal 爆速三国-フルスロットル Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『爆速三国-フルスロットル』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『爆速三国-フルスロットル』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          '爆速三国-フルスロットル 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 爆速三国-フルスロットル 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 爆速三国-フルスロットル 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny 爆速三国-フルスロットル. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações 爆速三国-フルスロットル. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «爆速三国-フルスロットル». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน 爆速三国-フルスロットル อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน 爆速三国-フルスロットル ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน 爆速三国-フルスロットル เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya 爆速三国-フルスロットル Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành 爆速三国-フルスロットル có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành 爆速三国-フルスロットル chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành 爆速三国-フルスロットル xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          '爆速三国-フルスロットル 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 爆速三国-フルスロットル 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 爆速三国-フルスロットル 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          '爆速三国-フルスロットル 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 爆速三国-フルスロットル 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 爆速三国-フルスロットル 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: `//auto-page.${mainHost}/baye2jpline/`, // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/line.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Line'
        //   }
        // }
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://x.com/BaoGuo38293', // 跳转链接
          linkKey: 'twitter', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-twitter-ico.png'), //ico
          btnColor: '#000000', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'X'
          }
        },
        {
          link: 'https://www.facebook.com/profile.php?id=61567083118083', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        },
        {
          link: `//auto-page.${mainHost}/baye2jpline/?language=ja-JP&cid=pay&scid=communitylist`, // 跳转链接
          linkKey: 'line', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-line-ico.png'), //ico
          btnColor: '#06C755', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Line'
          }
        },
        {
          link: `https://www.${mainHost}/official_website/index.html?name=sangokujp`, // 跳转链接
          linkKey: 'homepage', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-website-ico.png'), //ico
          btnColor: '#ffa200', // 按钮颜色
          text: {
            // 文案配置
            'en-US': '公式サイト'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/bwzytw/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/bwzytw/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/bwzytw/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/bwzytw/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/bwzyjp/bwzyjp-currency-guide.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#886122', //渐变按钮左
      gradientBtnRight: '#c69546', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#886122', //所有框体边框色高亮
      borderActiveShade: '#ecdecb', // 所有框体边框高亮阴影色
      btnBg: '#886122', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#ecdecb', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    isShowPreRightsPopup: true, // 是否展示上线前弹窗
    offLineTime: '2025-02-06T23:59:59+09:00', // 公告下线时间后不再弹窗时间，需加上时区信息
    offLineDate: {
      'zh-TW': '2025-02-06 23:59:59 (UTC+9)',
      'zh-CN': '2025-02-06 23:59:59 (UTC+9)',
      'vi-VN': '23:59:59 (UTC+9) ngày 02/06/2025',
      'tr-TR': '06/02/2025 23.59.59 (UTC+9)',
      'th-TH': '2025-02-06 เวลา 23:59:59 น.(UTC+9)',
      'ru-RU': '2025/02/06 23:59:59 (UTC+9)',
      'pt-PT': '06/02/2025 23:59:59 (UTC+9)',
      'pl-PL': '2025/02/06 23:59:59 (UTC+9)',
      'ko-KR': '2025-02-06 23:59:59(UTC+9)',
      'ja-JP': '2025 年 2 月 6 日 23:59:59(UTC+9)',
      'it-IT': '06/02/2025 23:59:59 (UTC+9)',
      'id-ID': '06/02/2025 23:59:59 (UTC+9)',
      'fr-FR': '06/02/2025 23:59:59 (UTC+9)',
      'es-ES': '06/02/2025 23:59:59 (UTC+9)',
      'en-US': '2025/02/06 23:59:59 (UTC+9)',
      'de-DE': '06.02.2025, 23:59:59 Uhr (UTC+9)',
      'ar-SA': '06-02-2025 23:59:59 (UTC+9)'
    }, // 配置公告下线时间
    preRightsPopupLink: '', // 上线前弹窗链接
    isOnlineRightsCenter: true, // 是否上线权益中心
    rightsCenterLink: `//auto-page.${mainHost}/byjpvip01/`, // 权益中心链接
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 霸业2.0越南版
  401: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'bwzyvn',
    //游戏名
    gameName: 'Cực Tốc Tam Quốc',
    //页面配置
    pageInfo: {
      pageTitle: 'Cực Tốc Tam Quốc', // 页面title
      pageIco: require('@assets/image/officialWebStore/bwzyvn/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/bwzyvn/icon401.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/bwzyvn/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/bwzyvn/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/bwzyvn/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        'en-US': []
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Cực Tốc Tam Quốc', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: '', // 多语言里面的规则前缀
      table: [],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: ''
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـ질풍삼국  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom 질풍삼국-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the 질풍삼국 Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de 질풍삼국. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de 질풍삼국. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          '질풍삼국 bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional 질풍삼국  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  질풍삼국  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal 질풍삼국 Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『질풍삼국』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『질풍삼국』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          '질풍삼국 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 질풍삼국 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 질풍삼국 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny 질풍삼국. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações 질풍삼국. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «질풍삼국». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน 질풍삼국 อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน 질풍삼국 ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน 질풍삼국 เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya 질풍삼국 Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành 질풍삼국 có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành 질풍삼국 chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành 질풍삼국 xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          '질풍삼국 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 질풍삼국 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 질풍삼국 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          '질풍삼국 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 질풍삼국 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 질풍삼국 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: `//auto-page.${mainHost}/dqseaeu_sfcz/`, // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/xddqsea/welfare-ico-1.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Total Top-Up Gift',
        //     'zh-CN': '累计充值领好礼',
        //     'zh-TW': '累計儲值領好禮',
        //     'ja-JP': '合計購入額で報酬GET',
        //     'ko-KR': '누적 충전 선물',
        //     'th-TH': 'เติมเงินสะสม รับรางวัล'
        //   }
        // }
      ],
      // 社群列表
      communityList: [
        // {
        //   link: '', // 跳转链接
        //   linkKey: 'discord', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/community-discord-ico.png'), //ico
        //   btnColor: '#6665d2', // 按钮颜色
        //   text: {
        //     // 文案配置
        //     'en-US': 'Discord'
        //   }
        // }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/bwzyvn/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/bwzyvn/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/bwzyvn/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/bwzyvn/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        // require('@assets/image/officialWebStore/bwzyvn/bwzyvn-currency-guide.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#8c6f4a', //渐变按钮左
      gradientBtnRight: '#dbb96e', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#90734c', //所有框体边框色高亮
      borderActiveShade: '#ecdfcb', // 所有框体边框高亮阴影色
      btnBg: '#90734c', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#ecdfcb', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    isShowPreRightsPopup: false, // 是否展示上线前弹窗
    offLineTime: '2025-02-06T23:59:59+09:00', // 公告下线时间后不再弹窗时间，需加上时区信息
    offLineDate: {
      'zh-TW': '2025-02-06 23:59:59 (UTC+9)',
      'zh-CN': '2025-02-06 23:59:59 (UTC+9)',
      'vi-VN': '23:59:59 (UTC+9) ngày 02/06/2025',
      'tr-TR': '06/02/2025 23.59.59 (UTC+9)',
      'th-TH': '2025-02-06 เวลา 23:59:59 น.(UTC+9)',
      'ru-RU': '2025/02/06 23:59:59 (UTC+9)',
      'pt-PT': '06/02/2025 23:59:59 (UTC+9)',
      'pl-PL': '2025/02/06 23:59:59 (UTC+9)',
      'ko-KR': '2025-02-06 23:59:59(UTC+9)',
      'ja-JP': '2025 年 2 月 6 日 23:59:59(UTC+9)',
      'it-IT': '06/02/2025 23:59:59 (UTC+9)',
      'id-ID': '06/02/2025 23:59:59 (UTC+9)',
      'fr-FR': '06/02/2025 23:59:59 (UTC+9)',
      'es-ES': '06/02/2025 23:59:59 (UTC+9)',
      'en-US': '2025/02/06 23:59:59 (UTC+9)',
      'de-DE': '06.02.2025, 23:59:59 Uhr (UTC+9)',
      'ar-SA': '06-02-2025 23:59:59 (UTC+9)'
    }, // 配置公告下线时间
    preRightsPopupLink: '', // 上线前弹窗链接
    isOnlineRightsCenter: true, // 是否上线权益中心
    rightsCenterLink: `//auto-page.${mainHost}/byvnvip01/`, // 权益中心链接
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 休闲三消全球版
  286: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'codemr',
    //游戏名
    gameName: 'Seaside Resort: Match 3',
    //页面配置
    pageInfo: {
      pageTitle: 'Official Top-Up', // 页面title
      pageIco: require('@assets/image/officialWebStore/codemr/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/codemr/icon286.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/codemr/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/codemr/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/codemr/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/tmslg/banner.png'), // 图片
        //     link: '//www.baidu.com' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: false, // 是否开启优惠券入口
      isOpenVip: false, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Seaside Resort: Match 3', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              // 文案
              text: '6%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              text: '9%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/codemr/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/codemr/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـSeaside Resort: Match 3  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Seaside Resort: Match 3-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the Seaside Resort: Match 3 Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Seaside Resort: Match 3. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Seaside Resort: Match 3. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'Seaside Resort: Match 3 bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Seaside Resort: Match 3  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  Seaside Resort: Match 3  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Seaside Resort: Match 3 Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『Seaside Resort: Match 3』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『Seaside Resort: Match 3』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          'Seaside Resort: Match 3 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 Seaside Resort: Match 3 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 Seaside Resort: Match 3 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Seaside Resort: Match 3. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Seaside Resort: Match 3. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Seaside Resort: Match 3». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน Seaside Resort: Match 3 อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน Seaside Resort: Match 3 ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน Seaside Resort: Match 3 เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya Seaside Resort: Match 3 Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành Seaside Resort: Match 3 có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Seaside Resort: Match 3 chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Seaside Resort: Match 3 xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'Seaside Resort: Match 3 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Seaside Resort: Match 3 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 Seaside Resort: Match 3 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'Seaside Resort: Match 3 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Seaside Resort: Match 3 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 Seaside Resort: Match 3 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: `//auto-page.${mainHost}/dqseaeu_sfcz/`, // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/xddqsea/welfare-ico-1.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Total Top-Up Gift',
        //     'zh-CN': '累计充值领好礼',
        //     'zh-TW': '累計儲值領好禮',
        //     'ja-JP': '合計購入額で報酬GET',
        //     'ko-KR': '누적 충전 선물',
        //     'th-TH': 'เติมเงินสะสม รับรางวัล'
        //   }
        // }
      ],
      // 社群列表
      communityList: [
        // {
        //   link: '', // 跳转链接
        //   linkKey: 'discord', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/tmslg/community-discord-ico.png'), //ico
        //   btnColor: '#6665d2', // 按钮颜色
        //   text: {
        //     // 文案配置
        //     'en-US': 'Discord'
        //   }
        // }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/codemr/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/codemr/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/codemr/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/codemr/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      // 'en-US': [
      //   require('@assets/image/officialWebStore/codemr/codemr-currency-guide.png')
      // ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#05613c', //渐变按钮左
      gradientBtnRight: '#178255', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#0d7147', //所有框体边框色高亮
      borderActiveShade: '#e8eccb', // 所有框体边框高亮阴影色
      btnBg: '#0d7147', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#e8eccb', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/dtmslg/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/dtmslg/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/dtmslg/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 猪猪保卫战台港澳版
  389: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'piggy',
    //游戏名
    gameName: '豬豬保衛戰',
    //页面配置
    pageInfo: {
      pageTitle: '儲值超優惠-豬豬保衛戰', // 页面title
      pageIco: require('@assets/image/officialWebStore/piggy/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/piggy/icon389.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/piggy/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/piggy/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/piggy/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        // 'en-US': [
        //   {
        //     img: require('@assets/image/officialWebStore/xddqsea/banner-invite.jpg'), // 图片
        //     link: 'https://auto-page.blancozone.com/dqxx03/' // 跳转
        //   }
        // ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: true, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: '豬豬保衛戰', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              // 文案
              text: '6%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/piggy/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/piggy/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـ豬豬保衛戰  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom 豬豬保衛戰-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the 豬豬保衛戰 Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de 豬豬保衛戰. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de 豬豬保衛戰. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          '豬豬保衛戰 bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional 豬豬保衛戰  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  豬豬保衛戰  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal 豬豬保衛戰 Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『豬豬保衛戰』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『豬豬保衛戰』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          '豬豬保衛戰 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 豬豬保衛戰 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 豬豬保衛戰 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny 豬豬保衛戰. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações 豬豬保衛戰. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «豬豬保衛戰». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน 豬豬保衛戰 อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน 豬豬保衛戰 ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน 豬豬保衛戰 เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya 豬豬保衛戰 Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành 豬豬保衛戰 có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành 豬豬保衛戰 chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành 豬豬保衛戰 xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          '豬豬保衛戰 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 豬豬保衛戰 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 豬豬保衛戰 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          '豬豬保衛戰 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 豬豬保衛戰 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 豬豬保衛戰 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        // {
        //   link: '//auto-page.blancozone.com/dqxx03/', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/xddqsea/welfare-ico-2.png'), //ico
        //   defaultLang: 'en-US', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'en-US': 'Cultivation Supply Pack',
        //     'zh-CN': '修仙补给礼包',
        //     'zh-TW': '修仙補給禮包',
        //     'ja-JP': '修行補給ギフトパック',
        //     'ko-KR': '수선 보급 패키지',
        //     'th-TH': 'ชุดของขวัญเสบียงการเพาะปลูก',
        //     'vi-VN': 'Gói Tiếp Tế Tu Tiên'
        //   }
        // }
        // {
        //   link: '//guide.mycard520.com/mycard/152323/#event1', // 跳转链接
        //   linkKey: '', // 链接key，用于打点上报
        //   ico: require('@assets/image/officialWebStore/xddq/welfare-ico-1.png'), //ico
        //   defaultLang: 'zh-TW', // 文案默认语言
        //   text: {
        //     // 文案配置
        //     'zh-TW': '人人龍有獎 ｜ MyCard'
        //   }
        // }
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/OinkOinkRush', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/piggy/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/piggy/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/piggy/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/piggy/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/piggy/piggy-currency-guide-1.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#3699ff', //渐变按钮左
      gradientBtnRight: '#6cb4ff', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#3699ff', //所有框体边框色高亮
      borderActiveShade: '#cbe3ff', // 所有框体边框高亮阴影色
      btnBg: '#3699ff', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#cbe3ff', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'zh-TW', // 默认语言
      resource: {
        // 'zh-TW': {
        //   close: require('@assets/image/officialWebStore/xddq/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/xddq/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/xddq/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  },
  // 精灵盛典欧美版
  390: {
    // 平台
    platform: 'global',
    //默认语言，与各种语言相关配置有关
    defaultLang: 'en-US',
    // 游戏简码
    gameCode: 'muglo',
    //游戏名
    gameName: 'MU: Dark Epoch',
    //页面配置
    pageInfo: {
      pageTitle: 'MU official top-up', // 页面title
      pageIco: require('@assets/image/officialWebStore/muglo/page-ico.png'), // 页面ico
      appleTouchIcon: require('@assets/image/officialWebStore/muglo/icon390.png') // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    },
    // 顶部栏背景，配置Pc端的，尺寸1920x106，
    topBar: require('@assets/image/officialWebStore/muglo/top-bar.png'),
    //顶部栏logo、pc端侧边栏logo,尺寸192x192
    logo: {
      'en-US': require('@assets/image/officialWebStore/muglo/logo.png') //英文logo
    },
    // banner轮播图
    banner: {
      defaultImg: require('@assets/image/officialWebStore/muglo/banner.jpg'), // 无轮播时默认图片
      list: {
        // 轮播图列表
        'en-US': [
          {
            img: require('@assets/image/officialWebStore/muglo/banner.png') // 图片
            // link: `//auto-page.${mainHost}/mukf01/` // 跳转
          }
        ]
      }
    },
    // 登录中心配置
    loginCenter: {
      isOpenCoupon: true, // 是否开启优惠券入口
      isOpenVip: false, // 是否开启vip入口，开启后进入页面会请求vip发券
      isOpenMoreCoupon: true //是否开启更多优惠入口
    },
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'MU: Dark Epoch', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw', // 多语言里面的规则前缀
      table: [
        {
          reachPoint: '100', //当前等级需要达到的积分数
          reward: [
            // 奖励列表
            {
              // ico
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              // 文案
              text: '6%OFF${couponCoupon}*1',
              // 标签 - newVipWeekly:每周赠送
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '1000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '5000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '10000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            }
          ]
        },
        {
          reachPoint: '20000',
          reward: [
            {
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              text: '15%OFF${couponCoupon}*1',
              tag: ''
            },
            {
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              text: '5%OFF${couponCoupon}*10',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              text: '6%OFF${couponCoupon}*5',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              text: '7%OFF${couponCoupon}*3',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              text: '8%OFF${couponCoupon}*2',
              tag: 'newVipWeekly'
            },
            {
              ico: require('@assets/image/officialWebStore/muglo/vip-coupon.png'),
              text: '10%OFF${couponCoupon}*1',
              tag: 'newVipWeekly'
            }
          ]
        }
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: '',
      // banner背景图
      bannerBg: require('@assets/image/officialWebStore/muglo/vip-banner-bg.png')
    },
    // 代币配置
    coinConfig: {
      // 代币名称
      coinsName: 'default', // default: 则使用默认文案，非default则使用配置的文案
      // 代币多语言说明，每个游戏的说明不一样
      coinsIntro: {
        'ar-SA':
          'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـMU: Dark Epoch  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
        'de-DE':
          'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom MU: Dark Epoch-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
        'en-US':
          'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the MU: Dark Epoch Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
        'es-ES':
          'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de MU: Dark Epoch. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
        'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de MU: Dark Epoch. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
        'id-ID':
          'MU: Dark Epoch bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional MU: Dark Epoch  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  MU: Dark Epoch  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
        'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal MU: Dark Epoch Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
        'ja-JP':
          '『MU: Dark Epoch』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『MU: Dark Epoch』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
        'ko-KR':
          'MU: Dark Epoch 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 MU: Dark Epoch 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 MU: Dark Epoch 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
        'pl-PL':
          'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny MU: Dark Epoch. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
        'pt-PT':
          'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações MU: Dark Epoch. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
        'ru-RU':
          'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «MU: Dark Epoch». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
        'th-TH':
          'ทีมงาน MU: Dark Epoch อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน MU: Dark Epoch ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน MU: Dark Epoch เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
        'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya MU: Dark Epoch Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
        'vi-VN':
          'Nhóm vận hành MU: Dark Epoch có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành MU: Dark Epoch chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành MU: Dark Epoch xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
        'zh-CN':
          'MU: Dark Epoch 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 MU: Dark Epoch 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 MU: Dark Epoch 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
        'zh-TW':
          'MU: Dark Epoch 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 MU: Dark Epoch 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 MU: Dark Epoch 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
      }
    },
    // 福利活动
    welfareConfig: {
      // 活动列表
      welfareList: [
        {
          link: `//auto-page.${mainHost}/mukf01/`, // 跳转链接
          linkKey: '', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/muglo/welfare-ico-1.png'), //ico
          defaultLang: 'en-US', // 文案默认语言
          text: {
            // 文案配置
            'en-US': 'Claim Your Reward！'
          }
        }
      ],
      // 社群列表
      communityList: [
        {
          link: 'https://www.facebook.com/profile.php?id=61562345821406', // 跳转链接
          linkKey: 'facebook', // 链接key，用于打点上报
          ico: require('@assets/image/officialWebStore/tmslg/community-fb-ico.png'), //ico
          btnColor: '#008aff', // 按钮颜色
          text: {
            // 文案配置
            'en-US': 'Facebook'
          }
        }
      ]
    },
    // 商品图标、加码、拆单图标
    product: {
      defaultIco: require('@assets/image/officialWebStore/muglo/defaultProductIco.png'), // 默认商品图标
      defaultCoinIco: require('@assets/image/officialWebStore/muglo/defaultCoinIco.png'), // 默认游戏币图标
      defaultVoucherIco: require('@assets/image/officialWebStore/muglo/defaultVoucherIco.png') // 默认代金币图标
    },
    //弹窗背景游戏素材,用于福利活动、关于代金币弹窗
    popupGameBg: require('@assets/image/officialWebStore/muglo/popup-game-sucai.png'),
    // 关于代金币弹窗引导图片
    aboutCurrenyGuideImg: {
      'en-US': [
        require('@assets/image/officialWebStore/muglo/muglo-currency-guide-1.png'),
        require('@assets/image/officialWebStore/muglo/muglo-currency-guide-2.png')
      ]
    },
    // 页面文字、ico色值配置
    colorConfig: {
      bg: '#f0f0f0', // 首页背景色
      gradientBtnLeft: '#49658f', //渐变按钮左
      gradientBtnRight: '#6c8bbb', //渐变按钮右
      border: '#ebebeb', //所有框体边框色
      borderActive: '#49658f', //所有框体边框色高亮
      borderActiveShade: '#d5e0f2', // 所有框体边框高亮阴影色
      btnBg: '#49658f', // 大按钮、小ico背景色；颜色文字的颜色
      btnShade: '#d5e0f2', // 大按钮阴影色
      productName: '#d5962d', //商品名
      gradientBgLeft: '#fff', //渐变背景左
      gradientBgRight: '#fff7e8', //渐变背景右
      popupSubBtn: '#7a9d1e', // 弹窗次要按钮背景色
      popupTitleBg: '#f6f6f6', //弹窗标题背景色
      popupTitleText: '#333', //弹窗标题色
      lightBg: '#fff7e8' //浅色背景，用于角色模块、平台币页面
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 欢迎页配置（进入页面时的弹窗）
    welcomePopupConfig: {
      isOpen: false, // 是否开启
      defaultLang: 'en-US', // 默认语言
      resource: {
        // 'en-US': {
        //   close: require('@assets/image/officialWebStore/xddq/welcome-popup-close.png'), //关闭按钮
        //   bg: require('@assets/image/officialWebStore/xddq/welcome-popup-bg.png'), //背景图
        //   btn: require('@assets/image/officialWebStore/xddq/welcome-popup-btn.png'), //按钮
        //   link: '//guide.mycard520.com/mycard/152323/#event1' //跳转链接
        // }
      }
    },
    isUidGuideShow: false, // 是否显示uid引导
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    }
  }
};

// 卖礼包界面的游戏, 会展示商品分类、排序、筛选、搜索功能
export const SHOW_PACKAGE_GAME = [175, 331];
// 预显示商品接口、init_data接口不需要传pageType的游戏
export const NO_NEED_PAGE_TYPE_GAME = [371, 175, 331, 379];
// 因为这些游戏代金币类型的商品配置成package类型了 pageType=package
export const PAGE_TYPE_IS_PACKAGE_GAME = [286];
// 特殊处理 暂时只卖钻石的游戏 pageType=coin
export const PAGE_TYPE_IS_COIN_GAME = [365];

// 全球平台
const globalGameId = [
  175, 269, 295, 321, 307, 331, 335, 251, 343, 274, 285, 340, 337, 294, 314,
  333, 339, 310, 336, 361, 365, 349, 303, 301, 371, 372, 356, 379, 286, 389,
  390, 381, 382, 401
];

// 日本平台
const jpGameId = [2];

// 页面有效的gameId, 无效则跳404页面
export const VALID_GAME_ID = (() => {
  if (process.env.NODE_ENV === 'production') {
    return window.location.host.includes(
      window.atob('anBzdG9yZS4zN2dhbWVzLmNvbQ==')
    )
      ? jpGameId
      : globalGameId;
  } else {
    return [...globalGameId, ...jpGameId];
  }
})();

export default gameInfoConfig;
